import React, { useState, useEffect, useContext, useRef } from "react";
import Image from "react-bootstrap/Image";
import Form from "react-bootstrap/Form";
import "react-phone-input-2/lib/style.css";
import Button from "react-bootstrap/Button";
import { Link } from "react-router-dom";
import PlaceholderImg from "../../images/placeholder.png";
import EditIcon from "../../images/edit.svg";
import SuccessIcon from "../../images/success.svg";
import Modal from "react-bootstrap/Modal";
import BannerSection from "../../inc/BannerSection";
import Banner from "../../images/banner.jpg";
import TherapistSidebar from "../../inc/TherapistSidebar";
import {
  FaAlignLeft,
  FaChevronDown,
  FaChevronUp,
  FaCloudUploadAlt,
  FaFilePdf,
  FaTimes,
} from "react-icons/fa";
import { toast } from "react-toastify";
import { ValidationsService } from "../../../utility/services/ValidationsService";
import ConstConfig from "../../../utility/configs/constConfig";
import Functions from "../../../utility/services/Functions";
import ApiService from "../../../utility/services/ApiService";
import { AuthContext } from "../../../utility/services/AuthContext";
import { MultiSelect } from "react-multi-select-component";
import { LocalizationProvider } from "@mui/x-date-pickers";
import dayjs from "dayjs";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { TimePicker } from "@mui/x-date-pickers/TimePicker";
import Select from "react-dropdown-select";
import Otp_model from "../../common/components/Otp_model";
import Calendar from "react-calendar";
import heic2any from "heic2any";

const StartTime = new Date(new Date().setHours(9, 0, 0, 0)).toUTCString();
const EndTime = new Date(new Date().setHours(18, 0, 0, 0)).toUTCString();
const TherapistEditProfile = () => {
  // LOGICAL VARIABLES

  const [filterHideShow, setfilterHideShow] = useState(false);
  const [modalShow, setModalShow] = React.useState(false);
  const [showDelConfirmationModal, setShowDelConfirmationModal] =
    useState(false);

  const [validationsRes, setValidationsRes] = useState({});
  const [submit, setSubmit] = useState(false);

  const priceInputRefs = useRef([]);

  const {
    consoleService,
    set_user_details,
    logOut,
    adjustSecondTimestamp,
    formetDate,
    calculateAge,
    fileToBase64,
    get_simple_year_date_month_str,
    get_unique_id,
    localDateFromString,
    split_simple_year_date_month_from_str,
    formatYMD
  } = Functions();
  const {
    get_speciality,
    get_speciality_types,
    get_licence_list,
    get_language_list,
    update_therapist_profile,
    get_states,
    deactivate_account,
    verify_license,
  } = ApiService();
  const { setLoading, user } = useContext(AuthContext);
  const [show_otp_modal, setShowOtpModal] = useState(false);

  const errorStyle = {
    position: "relative",
    top: -10,
  };

  // DATA VARIABLES

  const userOldDetails = user.details;
  const [bio, setBio] = useState(userOldDetails.bio);
  const [daysArray, setDaysArray] = useState([...userOldDetails.availability]);

  const [pricingArr, setPricingArr] = useState([...userOldDetails.pricing]);

  const [firstName, setFirstName] = useState(userOldDetails.first_name);
  const [lastName, setLastName] = useState(userOldDetails.last_name);
  const [dob, setDob] = useState(
    split_simple_year_date_month_from_str(userOldDetails.dob)
  );

  const [email, setEmail] = useState(userOldDetails.email);

  const isOldUser =
    !userOldDetails.licenses ||
    (Array.isArray(userOldDetails.licenses) &&
      userOldDetails.licenses.length === 0);

  const [check_license_cond_for_old_user, setCheckLicenseCondForOldUser] =
    useState(false);

  // State to track if old user wants to verify license
  const [showLicenseFormForOldUser, setShowLicenseFormForOldUser] =
    useState(false);
  // Multiple licenses state management

  const [licenses, setLicenses] = useState([]);

  const [old_licenses, setOldLicenses] = useState(() => []);

  const [new_licenses, setNewLicenses] = useState([]);

  const [supervisor_name, setSupervisorName] = useState(
    userOldDetails.supervisor_name ? userOldDetails.supervisor_name : ""
  );
  const [speciality, setSpeciality] = useState([]);
  const [profile_img, setProfileImg] = useState("");

  const [language, setLanguage] = useState([]);
  const [imgPreview, setImgPreview] = useState(
    userOldDetails.profile_img
      ? `${ConstConfig.IMAGE_URL}/${userOldDetails.profile_img}`
      : PlaceholderImg
  );

  const [licence, setLicence] = useState([]);
  const [certificateList, setLicenceList] = useState([]);
  const [languageLIst, setLanguageList] = useState([]);
  const [specialityList, setSpecialityList] = useState([]);
  const [statesList, setStatesList] = useState([]);

  const [showDateModel, setShowDateModel] = useState(false);
  const [showExpiryDateModel, setShowExpiryDateModel] = useState(false);
  const [selected_license, setSelectedLicense] = useState({});
  const min_thirty_min_amt = 39;
  const min_sixty_min_amt = 59;

  const findThirtyMinEntry = pricingArr.findIndex(
    (item) => item.time_in_min == 30
  );
  const findSixtyMinEntry = pricingArr.findIndex(
    (item) => item.time_in_min == 60
  );
  const ThirtyMinCond =
    pricingArr[findThirtyMinEntry].price >= min_thirty_min_amt;
  const SixtyMinCond = pricingArr[findSixtyMinEntry].price >= min_sixty_min_amt;
 

  // USE EFFECT

  useEffect(() => {
    fetch_lists();
  }, []);

  useEffect(() => {
    set_licenses_function();
  }, [user]);

  useEffect(() => {
    validationsResFun();
  }, [
    firstName,
    dob,
    email,
    speciality,
    language,
    licence,
    daysArray,
    pricingArr,
    bio,
    licenses,
    supervisor_name,
  ]);

  // FUNCTIONS

  const onhandle = () => setModalShow(false);
  const sideBarHide = () => {
    setfilterHideShow(!filterHideShow);
  };

  const isOldDocument = (docId, old_licenses) => {
    try {
      return (
        Array.isArray(old_licenses) &&
        old_licenses.some((d) => d?.document_unique_id === docId)
      );
    } catch {
      return false;
    }
  };

  const computeStatus = (lic) => {
    try {
      // 1) expiry overrides everything
      if (lic?.expiry_date) {
        const today = new Date();
        today.setHours(0, 0, 0, 0);
        const d = new Date(lic.expiry_date);
        if (!isNaN(d) && d < today) return "expired";
      }

      // 2) use explicit status if present
      if (lic?.status === "approved" || lic?.status === "in_progress") {
        return lic.status;
      }

      // 3) legacy fallback: map old verified -> new status
      if (lic?.verified === "verified") return "approved";

      // default
      return "in_progress";
    } catch {
      return "in_progress";
    }
  };

  const getDuplicateLicenseNumbersForSubmit = (list) => {
    try {
      const seen = new Map();
      const dupes = new Set();
      (Array.isArray(list) ? list : []).forEach((lic) => {
        const num = String(lic?.license_number || "")
          .toUpperCase()
          .trim();
        if (!num) return; // ignore empty entries
        if (seen.has(num)) dupes.add(num);
        else seen.set(num, true);
      });
      return Array.from(dupes); // e.g., ["ABC123", "XYZ999"]
    } catch {
      return [];
    }
  };

  async function set_licenses_function() {
    if (
      userOldDetails.licenses &&
      Array.isArray(userOldDetails.licenses) &&
      userOldDetails.licenses.length > 0
    ) {
      const details = [];
      for (let license of userOldDetails.licenses) {
        const file_path = license.file_path
          ? `${ConstConfig.IMAGE_URL}/${license.file_path}`
          : null;

        const modify_data = {
          document_unique_id: get_unique_id(),
          db_id: license._id,
          license_number: license.license_number || "",
          state: license.state_name
            ? [{ label: license.state_name, value: license.state }]
            : [],
          document: license.file_path
            ? await urlToFile(
                file_path,
                file_path.split("/").pop(), // fileName
                file_path.includes(".pdf") ? "application/pdf" : "image/jpeg" // mimeType
              )
            : null,
          expiry_date: license.expiry_date
            ? split_simple_year_date_month_from_str(license.expiry_date)
            : "",
          status: computeStatus({
            status: license.status, // if backend already gives it
            verified: license.verified, // legacy support
            expiry_date: license.expiry_date,
          }),

          file_path: license.file_path,
        };
        details.push(modify_data);
      }

      const details_for_old_licenses = details.map((lic) => {
        delete lic._id;
        return lic;
      });
      details.forEach((d) => {
        d.status = computeStatus(d);
      });
      setLicenses([...details]);
      setOldLicenses([...details_for_old_licenses]);
    }
    // Fallback to old single license format
    else if (userOldDetails.license_number) {
      const certificate = userOldDetails.certificates?.[0];
      const file_path = `${ConstConfig.IMAGE_URL}/${certificate}`;
      const details = [
        {
          document_unique_id: get_unique_id(),
          license_number: userOldDetails.license_number || "",
          state: userOldDetails.state
            ? [{ label: userOldDetails.state, value: userOldDetails.state_id }]
            : [],
          document: await urlToFile(
            file_path,
            file_path.split("/").pop(), // fileName
            file_path.includes(".pdf") ? "application/pdf" : "image/jpeg" // mimeType
          ),
          expiry_date: "",
          status: "in_progress", // Set to false so user can verify
          db_id: null,
          file_path: certificate ? certificate : "",
        },
      ];
      const details_for_old_licenses = details.map((lic) => {
        delete lic._id;
        return lic;
      });
      details.forEach((d) => {
        d.status = computeStatus(d);
      });
      setLicenses([...details]);
      setOldLicenses([...details_for_old_licenses]);
    }
    // Default empty license for new users
    else {
      const details = [
        {
          document_unique_id: get_unique_id(),
          license_number: "",
          state: [],
          document: null,
          expiry_date: "",
          status: "in_progress",
          file_path: "",
          db_id: null,
        },
      ];
      const details_for_old_licenses = details.map((lic) => {
        delete lic._id;
        return lic;
      });
      details.forEach((d) => {
        d.status = computeStatus(d);
      });
      setLicenses([...details]);
      setOldLicenses([...details_for_old_licenses]);
    }
  }

  function validationsResFun() {
    setValidationsRes(
      ValidationsService({
        firstName,
        dob,
        email,
        speciality,
        licence,
        language,
        availability: daysArray,
        pricing: pricingArr,
        bio,
        licenses,
        supervisor_name,
      })
    );
  }

  async function fetch_lists() {
    setLoading(true);
    try {
      const res = await get_speciality_types();
      const licence_res = await get_licence_list();
      const language_res = await get_language_list();
      const states_res = await get_states();
      if (
        res.status === 1 &&
        licence_res.status === 1 &&
        language_res.status === 1 &&
        states_res.status === 1
      ) {
        const typeId = res.data?.[0]?._id;
        if (!typeId) return;
        const list_res = await get_speciality(typeId);
        const modifiedRes = licence_res.data.map((item) => {
          return { label: item.title, value: item._id };
        });
        const modifiedLanguageRes = language_res.data.map((item) => {
          return { label: item.title, value: item._id };
        });
        const old_licence = [];
        const old_languages = [];
        licence_res.data.forEach((mainItem) => {
          const isFind = userOldDetails.selected_certificates_id.some(
            (item) => item == mainItem._id
          );
          if (isFind) {
            old_licence.push({ label: mainItem.title, value: mainItem._id });
          }
        });
        language_res.data.forEach((mainItem) => {
          const isFind = userOldDetails.language_id.some(
            (item) => item == mainItem._id
          );
          if (isFind) {
            old_languages.push({ label: mainItem.title, value: mainItem._id });
          }
        });
        const modified_states_list = states_res.data.map((item) => {
          return { label: item.title, value: item._id };
        });
        setStatesList(modified_states_list);
        setLicence(old_licence);
        setLanguage(old_languages);
        setLicenceList([...modifiedRes]);
        setLanguageList([...modifiedLanguageRes]);
        if (list_res.status == 1) {
          const old_specialities = [];
          list_res.data.forEach((mainItem) => {
            const isFind = userOldDetails.speciality_id.some(
              (item) => item == mainItem._id
            );
            if (isFind) {
              old_specialities.push({
                label: mainItem.title,
                value: mainItem._id,
              });
            }
          });
          const modifiedRes = list_res.data.map((item) => {
            return { label: item.title, value: item._id };
          });
          setSpeciality(old_specialities);
          setSpecialityList([...modifiedRes]);
          setLoading(false);
        }
      }
    } catch (err) {
      setLoading(false);
      consoleService("Error in fetch lists function = ", err);
    }
  }

  const select_profile_img = async (files) => {
    try {
      if (files.length > 0) {
        const file = files[0];
        const imageTypeRegex = /image\/(jpg|jpeg|png|heic)/gm;
        const isMatch = file.type.match(imageTypeRegex);
        if (isMatch) {
          if (file.type === "image/heic" || file.name.endsWith(".heic")) {
            try {
              const blob = await heic2any({
                blob: file,
                toType: "image/jpeg",
              });
              const convertedFile = new File(
                [blob],
                file.name.replace(".heic", ".jpg"),
                { type: "image/jpeg" }
              );
              setImgPreview(URL.createObjectURL(convertedFile));
              setProfileImg(convertedFile);
            } catch (error) {
              toast(
                "Failed to process HEIC image. Please upload a JPG or PNG instead.",
                {
                  position: "top-center",
                  hideProgressBar: true,
                  type: "error",
                }
              );
              return;
            }
          } else {
            setImgPreview(URL.createObjectURL(file));
            setProfileImg(file);
          }
        } else {
          toast("Please select a file in JPG, PNG, HEIC, or JPEG format.", {
            position: "top-center",
            hideProgressBar: true,
            type: "error",
          });
        }
      }
    } catch (err) {
      consoleService("error in select_profile_img =", err);
    }
  };

  const check_uncheck_fun = (id) => {
    const check = daysArray.some((item) => {
      return item.id == id && item.checked == false;
    });

    const findEntry = daysArray.find((item) => item.id == id);

    if (check) {
      const startTime = new Date(findEntry.start_time);
      const end_time = new Date(findEntry.end_time);
      const time1 = startTime.getHours() * 60 + startTime.getMinutes();
      const time2 = end_time.getHours() * 60 + end_time.getMinutes();
      const condition = time1 < time2;
      if (!findEntry.start_time || !findEntry.end_time) {
        const newArray = daysArray.map((item) => {
          if (item.id == id) {
            item.checked = check;
            if (!item.start_time) {
              item.start_time = StartTime;
            }
            if (!item.end_time) {
              item.end_time = EndTime;
            }
            return item;
          } else {
            return item;
          }
        });
        setDaysArray([...newArray]);
      } else {
        if (condition) {
          const newArray = daysArray.map((item) => {
            if (item.id == id) {
              item.checked = check;
              return item;
            } else {
              return item;
            }
          });
          setDaysArray([...newArray]);
        } else {
          toast("Incorrect time schedule.", {
            position: "top-center",
            hideProgressBar: true,
            type: "error",
          });
        }
      }
    } else {
      const newArray = daysArray.map((item) => {
        if (item.id == id) {
          item.start_time = "";
          item.end_time = "";
          item.checked = check;
          return item;
        } else {
          return item;
        }
      });
      setDaysArray([...newArray]);
    }
  };

  async function urlToFile(url, fileName, mimeType) {
    if (!url) {
      return null;
    }

    const response = await fetch(url);
    const blob = await response.blob();
    const file = new File([blob], fileName, { type: mimeType });

    return file;
  }

  const setStartTimeFun = (id, time) => {
    const Time = new Date(time);
    const newArray = daysArray.map((item) => {
      if (item.id == id) {
        item.start_time = Time.toUTCString();
        return item;
      } else {
        return item;
      }
    });
    setDaysArray([...newArray]);
  };

  const setEndTimeFun = (id, time) => {
    const Time = new Date(time);
    const newArray = daysArray.map((item) => {
      if (item.id == id) {
        item.end_time = Time.toUTCString();
        return item;
      } else {
        return item;
      }
    });
    setDaysArray([...newArray]);
  };

  const setTimeValueFun = (id, value) => {
    const newArray = pricingArr.map((item) => {
      if (item.id == id) {
        item.price = value.toString();
        return item;
      } else {
        return item;
      }
    });
    setPricingArr([...newArray]);
  };

  const MInCond_toast = (amt) => {
    toast(`Price should be minimum ${amt}.`, {
      position: "top-center",
      hideProgressBar: true,
      type: "error",
    });
  };

  const check_uncheck_pricing_fun = (id, index) => {
    const check = pricingArr.some((item) => {
      return item.id == id && item.checked == false;
    });
    const condition = pricingArr.some((item) => {
      return item.id == id && item.price != "" && Number(item.price) > 0;
    });
    if (check) {
      if (condition) {
        if (index == findThirtyMinEntry && !ThirtyMinCond) {
          MInCond_toast(min_thirty_min_amt);
          return;
        } else if (index == findSixtyMinEntry && !SixtyMinCond) {
          MInCond_toast(min_sixty_min_amt);
          return;
        }
        const newArray = pricingArr.map((item) => {
          if (item.id == id) {
            item.checked = check;
            return item;
          } else {
            return item;
          }
        });
        setPricingArr([...newArray]);
      } else {
        if (index == findThirtyMinEntry) {
          const newArray = pricingArr.map((item) => {
            if (item.id == id) {
              item.checked = check;
              item.price = min_thirty_min_amt;
              return item;
            } else {
              return item;
            }
          });
          setPricingArr([...newArray]);
        } else if (index == findSixtyMinEntry) {
          const newArray = pricingArr.map((item) => {
            if (item.id == id) {
              item.checked = check;
              item.price = min_sixty_min_amt;
              return item;
            } else {
              return item;
            }
          });
          setPricingArr([...newArray]);
        }
      }
    } else {
      const newArray = pricingArr.map((item) => {
        if (item.id == id) {
          item.checked = check;
          return item;
        } else {
          return item;
        }
      });
      setPricingArr([...newArray]);
    }
  };

  function checkAvailability() {
    let errorDay = "";
    const condition = daysArray.some((findEntry) => {
      if (
        findEntry.checked &&
        findEntry.startTime != "" &&
        findEntry.end_time != ""
      ) {
        const startTime = new Date(findEntry.start_time);
        const end_time = new Date(findEntry.end_time);
        const time1 = startTime.getHours() * 60 + startTime.getMinutes();
        const time2 = end_time.getHours() * 60 + end_time.getMinutes();
        const condition = time1 < time2;
        if (!condition) {
          errorDay = findEntry.day;
        }
        return !condition;
      } else {
        return false;
      }
    });

    const isAvailabilityOK = !condition;

    return { isAvailabilityOK, errorDay };
  }

  const validateLicenses = () => {
    // 1) required fields
    for (const lic of licenses) {
      if (
        !lic.license_number ||
        !lic.state.length ||
        !lic.document ||
        !lic.expiry_date
      ) {
        return "All license fields are required";
      }
    }

    // 2) no duplicate license numbers (case-insensitive)
    const seen = new Set();
    for (const lic of licenses) {
      const k = String(lic.license_number).toUpperCase().trim();
      if (seen.has(k)) {
        return "Duplicate license numbers are not allowed.";
      }
      seen.add(k);
    }

    return null;
  };
  const validateLicensesForExpiryDate = () => {
    for (const lic of licenses) {
      if (!lic.license_number || !lic.state.length || !lic.document) {
        return "All license fields are required";
      }
    }
    return null;
  };

  const submitFun = async (otp, setOtpLoading) => {
    setLoading(true);

    try {
      const formData = new FormData();
      formData.append("first_name", firstName);
      formData.append("last_name", lastName);
      formData.append("dob", dob);
      formData.append("email", email);
      formData.append("otp", otp);
      if (profile_img) {
        formData.append("profile_img", profile_img);
      }

      formData.append(
        "speciality_id",
        JSON.stringify(speciality.map((item) => item.value))
      );

      formData.append(
        "certificates",
        JSON.stringify(licence.map((item) => item.value))
      );
      formData.append("bio", bio);
      formData.append(
        "language",
        JSON.stringify(language.map((item) => item.value))
      );
      // Send licenses array instead of single license_number
      const licensesData = new_licenses.map((lic, index) => ({
        license_number: lic.license_number,
        state: lic?.state?.length > 0 ? lic.state[0].value : "",
        file_path: "",
        expiry_date: lic.expiry_date,
        db_id: lic.db_id,
        verified: lic.verified == "not_checked" ? "unverified" : lic.verified,
      }));
      const old_licenses_data = old_licenses.map((lic, index) => {
        const item = { ...lic };
        item.state = lic?.state?.length > 0 ? lic.state[0].value : "";
        item.expiry_date = lic.expiry_date;

        return item;
      });

      if (isOldUser) {
        if (check_license_cond_for_old_user) {
          formData.append("new_licenses", JSON.stringify(licensesData));
          formData.append("licenses", JSON.stringify(old_licenses_data));
        } else {
          formData.append("new_licenses", JSON.stringify([]));
          formData.append("licenses", JSON.stringify([]));
        }
      } else {
        formData.append("new_licenses", JSON.stringify(licensesData));
        formData.append("licenses", JSON.stringify(old_licenses_data));
      }

      // Append license documents
      new_licenses.forEach((lic, index) => {
        if (lic.document) {
          formData.append(`license_document_${index}`, lic.document);
        }
      });

      formData.append("supervisor_name", supervisor_name);

      const resolvedSecondStampsDaysArr = daysArray.map((obj) => {
        const firstStamp = obj.start_time;
        const secondStamp = obj.end_time;
        if (obj.checked) {
          const newObj = obj;
          newObj.start_time = adjustSecondTimestamp(
            firstStamp,
            secondStamp
          ).firstDate;
          newObj.end_time = adjustSecondTimestamp(
            firstStamp,
            secondStamp
          ).secondDate;
          return newObj;
        } else {
          return obj;
        }
      });

      const final_availability = resolvedSecondStampsDaysArr.map((item) => {
        if (item.checked) {
          return item;
        } else {
          item.start_time = "";
          item.end_time = "";
          return item;
        }
      });
      formData.append("availability", JSON.stringify(final_availability));
      formData.append("pricing", JSON.stringify(pricingArr));

      const res = await update_therapist_profile(formData);

      if (res.status === 1) {
        await set_user_details();
        setShowOtpModal(false);
        setLoading(false);
        if (setOtpLoading != undefined) {
          setOtpLoading(false);
        }
        setSubmit(false);
        setNewLicenses([]);

        toast("Profile updated successfully", {
          position: "top-center",
          hideProgressBar: true,
          type: "success",
        });
      } else {
        setLoading(false);
        if (setOtpLoading != undefined) {
          setOtpLoading(false);
        }
        toast(res.message, {
          position: "top-center",
          hideProgressBar: true,
          type: "error",
        });
      }
    } catch (err) {
      setLoading(false);
      consoleService("Error in submit function = ", err);
    }
  };

  const handle_submit = async () => {
    if (!(calculateAge(dob) >= 12))
      return toast("You must be above 12 years of age to register.", {
        position: "top-center",
        hideProgressBar: true,
        type: "error",
      });
    const duplicateNums = getDuplicateLicenseNumbersForSubmit(licenses);
    if (duplicateNums.length > 0) {
      toast("Duplicate license numbers are not allowed.", {
        position: "top-center",
        hideProgressBar: true,
        type: "error",
      });
      return;
    }
    setSubmit(true);

    if (isOldUser) {
      if (check_license_cond_for_old_user) {
        const licenseValidationError = validateLicenses();
        if (licenseValidationError) {
          toast(licenseValidationError, {
            position: "top-center",
            hideProgressBar: true,
            type: "error",
          });
          return;
        }
      }
    } else {
      const licenseValidationError = validateLicenses();
      if (licenseValidationError) {
        toast(licenseValidationError, {
          position: "top-center",
          hideProgressBar: true,
          type: "error",
        });
        return;
      }
    }

    if (
      !validationsRes.firstNameErr &&
      !validationsRes.dobErr &&
      !validationsRes.emailErr &&
      !validationsRes.specialityErr &&
      !validationsRes.licenceErr &&
      !validationsRes.availabilityErr &&
      !validationsRes.languageErr &&
      !validationsRes.bioErr &&
      !validationsRes.licensesErr &&
      !validationsRes.pricingErr
    ) {
      const { isAvailabilityOK, errorDay } = checkAvailability();
      let Day = "";
      switch (errorDay) {
        case "Mon":
          Day = "Monday";
          break;
        case "Tue":
          Day = "Tuesday";
          break;
        case "Wed":
          Day = "Wednesday";
          break;
        case "Thu":
          Day = "Thursday";
          break;
        case "Fri":
          Day = "Friday";
          break;
        case "Sat":
          Day = "Saturday";
          break;
        case "Sun":
          Day = "Sunday";
          break;
      }
      if (!isAvailabilityOK)
        return toast("Invaild entry found on " + Day, {
          position: "top-center",
          hideProgressBar: true,
          type: "error",
        });

      if (
        (pricingArr[findThirtyMinEntry].checked && !ThirtyMinCond) ||
        (pricingArr[findSixtyMinEntry].checked && !SixtyMinCond)
      ) {
        return pricingArr[findThirtyMinEntry].checked && !ThirtyMinCond
          ? MInCond_toast(min_thirty_min_amt)
          : MInCond_toast(min_sixty_min_amt);
      }

      const phone = userOldDetails.phone;
      if (phone && phone.toString().trim()) {
        setShowOtpModal(true);
      } else {
        submitFun(null);
      }
    } else {
      toast("Some fields are missing.", {
        position: "top-center",
        hideProgressBar: true,
        type: "error",
      });
    }
  };

  const handleBlurOfPriceInput = (item, index) => {
    if (
      item.time_in_min == 30 &&
      item.checked &&
      priceInputRefs.current[index].value < min_thirty_min_amt
    ) {
      MInCond_toast(min_thirty_min_amt);
      priceInputRefs.current[index].focus();
    } else if (
      item.time_in_min == 60 &&
      item.checked &&
      priceInputRefs.current[index].value < min_sixty_min_amt
    ) {
      MInCond_toast(min_sixty_min_amt);
      priceInputRefs.current[index].focus();
    }
  };

  // NESTED COMPONENTS
  function Date_model(props) {
    const [selectedDate, setSelectedDate] = useState(
      dob
        ? new Date(
            localDateFromString(split_simple_year_date_month_from_str(dob))
          )
        : new Date(1940, 0, 1)
    );

    return (
      <Modal
        {...props}
        size="md"
        className="modalregs"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        onHide={() => {
          setSelectedDate(new Date(dob));
          setShowDateModel(false);
        }}
      >
        <Modal.Body className="text-left">
          <section className="pb-4 pt-2 packagebox packagebox_book">
            <div className="container">
              <div className="row">
                <div className="col-md-12">
                  <h2>Select Date</h2>
                  <Calendar
                    onChange={(date) => {
                      setSelectedDate(new Date(date));
                    }}
                    value={selectedDate}
                    minDate={new Date(1940, 0, 1)}
                    maxDate={new Date()}
                    tileClassName="calendar_tiles"
                  />
                </div>
              </div>
            </div>
          </section>
        </Modal.Body>
        <Modal.Footer>
          <Button
            as={Link}
            onClick={(e) => {
              e.preventDefault();
              setDob(
                formatYMD(selectedDate)
              );

              setShowDateModel(false);
            }}
          >
            Done
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }

  function Expiry_Date_model(props) {
    const lic = selected_license;
    const index = lic.index;

    const [selectedDate, setSelectedDate] = useState(
      lic.expiry_date
        ? localDateFromString(
            split_simple_year_date_month_from_str(lic.expiry_date)
          )
        : new Date()
    );

    return (
      <Modal
        {...props}
        size="md"
        className="modalregs"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        onHide={() => {
          setSelectedDate(new Date(lic.expiry_date));
          setShowExpiryDateModel(false);
        }}
      >
        <Modal.Body className="text-left">
          <section className="pb-4 pt-2 packagebox packagebox_book">
            <div className="container">
              <div className="row">
                <div className="col-md-12">
                  <h2>Select Date</h2>
                  <Calendar
                    onChange={(date) => {
                      setSelectedDate(new Date(date));
                    }}
                    value={selectedDate}
                    minDate={new Date()}
                    tileClassName="calendar_tiles"
                  />
                </div>
              </div>
            </div>
          </section>
        </Modal.Body>
        <Modal.Footer>
          <Button
            as={Link}
            onClick={(e) => {
              e.preventDefault();
              const updated = [...licenses];
              const extracted_new_licenses = [...new_licenses];
              const extracted_old_licenses = [...old_licenses];
              const index_of_new_license = extracted_new_licenses.findIndex(
                (license) =>
                  license.document_unique_id == lic.document_unique_id
              );
              const index_of_old_license = extracted_old_licenses.findIndex(
                (license) =>
                  license.document_unique_id == lic.document_unique_id
              );

              const modified_date = formatYMD(selectedDate);
              updated[index].expiry_date = modified_date;
              updated[index].status = computeStatus(updated[index]);
              if (index_of_new_license != -1) {
                extracted_new_licenses[index_of_new_license].expiry_date =
                  modified_date;
              }
              if (index_of_old_license != -1) {
                extracted_old_licenses[index_of_old_license].expiry_date =
                  modified_date;
              }
              setLicenses(updated);
              setNewLicenses(extracted_new_licenses);
              setOldLicenses(extracted_old_licenses);
              setShowExpiryDateModel(false);
            }}
          >
            Done
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }

  function MyVerticallyCenteredModal(props) {
    return (
      <Modal
        {...props}
        size="sm"
        className="modalSuccess"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Body>
          <Image src={SuccessIcon} alt="" />
          <h4>Success</h4>
          <p>Your account has been created successfully!</p>
        </Modal.Body>
        <Modal.Footer>
          <Button as={Link} onClick={onhandle}>
            OK
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }

  const DeleteAccountConfirmationModal = (props) => {
    const deleteAccount = async () => {
      try {
        setShowDelConfirmationModal(false);
        setLoading(true);
        const res = await deactivate_account();
        if (res.status === 1) {
          setLoading(false);
          logOut();
        }
      } catch (err) {
        consoleService("error in delete Account function = ", err);
      }
    };

    return (
      <Modal
        {...props}
        size="sm"
        className="modalSuccess modalBtn"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Body>
          <h4>Are you Sure?</h4>
          <p className="mb-1">
            To delete your account.You can reactivate your account if you log in
            within 7 days. After seven days, your account will be permanently
            deleted.
          </p>
        </Modal.Body>
        <Modal.Footer>
          <Button
            as={Link}
            onClick={() => {
              setShowDelConfirmationModal(false);
            }}
          >
            No
          </Button>
          <Button
            // as={Link}
            onClick={() => {
              deleteAccount();
            }}
          >
            Delete
          </Button>
        </Modal.Footer>
      </Modal>
    );
  };

  // MAIN RETURN

  return (
    <>
      <div className="breadHidePhone">
        <BannerSection banner={Banner} name={"Home"} title={"Edit Profile"} />
      </div>
      <section className="py-5 useraccount bg-light_dash profCheckbox">
        <div className="container">
          {licenses.length > 0 && (
            <div className="row">
              <div
                className={`col-xl-3 col-md-4 ${
                  filterHideShow ? "leftShow" : "leftHide"
                }`}
              >
                <TherapistSidebar />
              </div>
              <div className="col-xl-9 col-md-8 fulltabBox">
                <div className="filterBox">
                  <Link className="filterIcon" onClick={sideBarHide}>
                    <FaAlignLeft />
                  </Link>
                </div>
                <div className="dashboard-widg-bar d-block">
                  <div className="dashboard_body">
                    <h4 className="mb-4 ft-medium">Personal Information</h4>
                    <Form>
                      <div className="loginBox loginUpdateBox">
                        <div className="userImg">
                          <Image
                            src={imgPreview ? imgPreview : PlaceholderImg}
                            className="userImage"
                            alt=""
                          />
                          <div>
                            <Image src={EditIcon} className="editIcon" alt="" />
                            <input
                              type="file"
                              accept="image/jpg, image/jpeg, image/png, image/heic"
                              className="edit_img"
                              multiple={false}
                              onChange={(e) => {
                                select_profile_img(e.target.files);
                              }}
                            />
                          </div>
                        </div>

                        <Form.Control
                          type="text"
                          placeholder="First Name"
                          value={firstName}
                          onChange={(e) => setFirstName(e.target.value)}
                        />
                        {submit && validationsRes.firstNameErr && (
                          <span className="validations_err" style={errorStyle}>
                            {validationsRes.firstNameErr}
                          </span>
                        )}
                        <Form.Control
                          type="text"
                          placeholder="Last Name"
                          value={lastName}
                          onChange={(e) => setLastName(e.target.value)}
                        />

                        <Form.Control
                          className="mb-3"
                          type="text"
                          placeholder="D.O.B."
                          value={dob && get_simple_year_date_month_str(dob)}
                          onClick={() => {
                            setShowDateModel(true);
                          }}
                        />
                        {!submit && !validationsRes.dobErr && (
                          <small>
                            You must be above 12 years of age to register
                          </small>
                        )}
                        {submit && validationsRes.dobErr && (
                          <span className="validations_err" style={errorStyle}>
                            {validationsRes.dobErr}
                          </span>
                        )}
                        <Form.Control
                          type="text"
                          placeholder="Email Address"
                          value={email}
                          onChange={(e) => setEmail(e.target.value)}
                        />
                        {submit && validationsRes.emailErr && (
                          <span className="validations_err" style={errorStyle}>
                            {validationsRes.emailErr}
                          </span>
                        )}
                        <Form.Control
                          type="text"
                          as={"textarea"}
                          rows={4}
                          style={{
                            height: "auto",
                          }}
                          placeholder="Enter Your Bio"
                          value={bio}
                          onChange={(e) => setBio(e.target.value)}
                        />
                        {submit && validationsRes.bioErr && (
                          <span className="validations_err" style={errorStyle}>
                            {validationsRes.bioErr}
                          </span>
                        )}

                        {isOldUser && !showLicenseFormForOldUser ? (
                          <React.Fragment>
                            <Form.Group
                              className="mt-3"
                              controlId="exampleForm.ControlInput3"
                            >
                              <div className="d-flex justify-content-between align-items-center mb-3">
                                <Form.Label className="mb-0">
                                  License Number
                                </Form.Label>
                                <span
                                  style={{
                                    color: "#1D7E7C",
                                    cursor: "pointer",
                                    fontWeight: "bold",
                                    fontSize: "15px",
                                  }}
                                  onClick={() => {
                                    setShowLicenseFormForOldUser(true);
                                    setCheckLicenseCondForOldUser(true);

                                    setNewLicenses([...old_licenses]);
                                    setOldLicenses([]);
                                  }}
                                >
                                  Verify your license
                                </span>
                              </div>
                              <Form.Control
                                type="text"
                                placeholder="License Number"
                                value={userOldDetails.license_number}
                                disabled={true}
                                style={{ textTransform: "uppercase" }}
                              />
                            </Form.Group>

                            <Form.Group
                              className="mt-3"
                              controlId="exampleForm.ControlInput3"
                            >
                              <Form.Label className="mb-3">State</Form.Label>
                              <Form.Control
                                type="text"
                                placeholder="State"
                                value={userOldDetails.state}
                                disabled={true}
                              />
                            </Form.Group>
                          </React.Fragment>
                        ) : (
                          <Form.Group
                            className="mt-3"
                            controlId="exampleForm.ControlInput3"
                          >
                            <Form.Label>Licensing Information</Form.Label>
                            {licenses.map((lic, index) => {
                              const today = new Date();
                              today.setHours(0, 0, 0, 0); // remove time part
                              const expiry = lic.expiry_date
                                ? new Date(lic.expiry_date)
                                : null;

                              return (
                                <div
                                  key={index}
                                  className="licenseBox shadow p-3 mt-3 mb-3 bg-body rounded position-relative"
                                >
                                  <div className="d-flex align-items-center  pb-1">
                                    <p className="mb-0 me-2">
                                      License #{index + 1}
                                    </p>
                                    <div className="ms-auto d-flex align-items-center me-4">
                                      {(() => {
                                        // Show tag ONLY if this document exists in old_licenses
                                        if (
                                          !isOldDocument(
                                            lic.document_unique_id,
                                            old_licenses
                                          )
                                        )
                                          return null;

                                        // prefer explicit field if present, else compute dynamically
                                        const status =
                                          lic.status || computeStatus(lic);

                                        if (status === "approved") {
                                          return (
                                            <span
                                              className="badge bg-success"
                                              style={{ fontSize: "12px" }}
                                            >
                                              Approved
                                            </span>
                                          );
                                        }
                                        if (status === "in_progress") {
                                          return (
                                            <span
                                              className="badge bg-info"
                                              style={{ fontSize: "12px" }}
                                            >
                                              In&nbsp;Progress
                                            </span>
                                          );
                                        }
                                        if (status === "expired") {
                                          return (
                                            <span
                                              className="badge bg-warning"
                                              style={{ fontSize: "12px" }}
                                            >
                                              Expired
                                            </span>
                                          );
                                        }
                                        return null;
                                      })()}
                                    </div>
                                  </div>
                                  {/* REMOVE BUTTON */}
                                  {licenses.length > 1 && (
                                    <FaTimes
                                      className="position-absolute"
                                      style={{
                                        top: 10,
                                        right: 10,
                                        cursor: "pointer",
                                        color: "red",
                                        opacity: 1,
                                      }}
                                      onClick={() => {
                                        const updated = [...licenses];
                                        const new_licence_updated =
                                          new_licenses.filter(
                                            (item) =>
                                              item.document_unique_id !=
                                              lic.document_unique_id
                                          );
                                        const removed_old_licenses =
                                          old_licenses.filter(
                                            (item) =>
                                              item.document_unique_id !=
                                              lic.document_unique_id
                                          );
                                        updated.splice(index, 1);
                                        setOldLicenses([
                                          ...removed_old_licenses,
                                        ]);
                                        setNewLicenses([
                                          ...new_licence_updated,
                                        ]);
                                        setLicenses(updated);
                                      }}
                                    />
                                  )}
                                  <Form.Control
                                    type="text"
                                    placeholder="License Number"
                                    value={lic.license_number}
                                    onChange={(e) => {
                                      const value =
                                        e.target.value.toUpperCase();

                                      const updated = [...licenses];
                                      updated[index].license_number = value;
                                      updated[index].status = computeStatus(
                                        updated[index]
                                      );
                                      const extracted_new_licenses = [
                                        ...new_licenses,
                                      ];
                                      const extracted_old_licenses = [
                                        ...old_licenses,
                                      ];
                                      const index_of_new_license =
                                        extracted_new_licenses.findIndex(
                                          (item) =>
                                            item.document_unique_id ==
                                            lic.document_unique_id
                                        );
                                      if (index_of_new_license != -1) {
                                        extracted_new_licenses[
                                          index_of_new_license
                                        ].license_number = value;
                                      }
                                      const index_of_old_license =
                                        extracted_old_licenses.findIndex(
                                          (item) =>
                                            item.document_unique_id ==
                                            lic.document_unique_id
                                        );
                                      if (index_of_old_license != -1) {
                                        extracted_old_licenses[
                                          index_of_old_license
                                        ].license_number = value;
                                      }
                                      setLicenses(updated);
                                      setNewLicenses(extracted_new_licenses);
                                      setOldLicenses(extracted_old_licenses);
                                    }}
                                    style={{
                                      textTransform: lic.license_number
                                        ? "uppercase"
                                        : "none",
                                    }}
                                  />

                                  <Select
                                    placeholder="Select State"
                                    className={` `}
                                    options={statesList}
                                    values={lic.state}
                                    onChange={(value) => {
                                      const updated = [...licenses];
                                      updated[index].state = value;
                                      updated[index].status = computeStatus(
                                        updated[index]
                                      );
                                      const extracted_new_licenses = [
                                        ...new_licenses,
                                      ];
                                      const extracted_old_licenses = [
                                        ...old_licenses,
                                      ];
                                      const index_of_new_license =
                                        extracted_new_licenses.findIndex(
                                          (item) =>
                                            item.document_unique_id ==
                                            lic.document_unique_id
                                        );
                                      if (index_of_new_license != -1) {
                                        extracted_new_licenses[
                                          index_of_new_license
                                        ].state = value;
                                      }
                                      const index_of_old_license =
                                        extracted_old_licenses.findIndex(
                                          (item) =>
                                            item.document_unique_id ==
                                            lic.document_unique_id
                                        );
                                      if (index_of_old_license != -1) {
                                        extracted_old_licenses[
                                          index_of_old_license
                                        ].state = value;
                                      }
                                      setLicenses(updated);
                                      setNewLicenses(extracted_new_licenses);
                                      setOldLicenses(extracted_old_licenses);
                                    }}
                                    multi={false}
                                    style={{
                                      color: "#212529",
                                      borderColor: "#E9ECEF",
                                      opacity: 1,
                                    }}
                                    dropdownHandleRenderer={({ state }) => (
                                      <span
                                        style={{
                                          color: "#212529",
                                          opacity: 0,
                                        }}
                                      >
                                        {state.dropdown ? (
                                          <FaChevronUp />
                                        ) : (
                                          <FaChevronDown />
                                        )}
                                      </span>
                                    )}
                                  />
                                  {/* UPLOAD BOX */}
                                  <div className="uploadBox mt-3">
                                    <p>
                                      Please upload proof of license
                                      certification
                                    </p>
                                    <div
                                      className="file"
                                      style={{
                                        position: "relative",
                                        cursor: "pointer",
                                      }}
                                      onClick={() => {
                                        const fileInput =
                                          document.getElementById(
                                            `license-file-${index}`
                                          );
                                        if (fileInput) fileInput.value = null;
                                        document
                                          .getElementById(
                                            `license-file-${index}`
                                          )
                                          .click();
                                      }}
                                    >
                                      {licenses[index].document ? (
                                        licenses[index].document.isExisting ? (
                                          // Existing document preview
                                          licenses[
                                            index
                                          ].document.type.includes("image") ? (
                                            <img
                                              src={licenses[index].document.url}
                                              alt="preview"
                                              style={{
                                                width: "100%",
                                                height: "150px",
                                                objectFit: "contain",
                                                border: "1px solid #ccc",
                                              }}
                                            />
                                          ) : (
                                            <div
                                              style={{
                                                width: "100%",
                                                height: "150px",
                                                border: "1px solid #ccc",
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                flexDirection: "column",
                                              }}
                                            >
                                              <FaFilePdf
                                                size={40}
                                                color="red"
                                              />
                                              <p
                                                style={{
                                                  fontSize: "12px",
                                                  marginTop: 5,
                                                }}
                                              >
                                                {licenses[index].document.name}
                                              </p>
                                            </div>
                                          )
                                        ) : // New uploaded document preview
                                        licenses[index].document.type.includes(
                                            "image"
                                          ) ? (
                                          <img
                                            src={URL.createObjectURL(
                                              licenses[index].document
                                            )}
                                            alt="preview"
                                            style={{
                                              width: "100%",
                                              height: "150px",
                                              objectFit: "contain",
                                              border: "1px solid #ccc",
                                            }}
                                          />
                                        ) : (
                                          <div
                                            style={{
                                              width: "100%",
                                              height: "150px",
                                              border: "1px solid #ccc",
                                              display: "flex",
                                              alignItems: "center",
                                              justifyContent: "center",
                                              flexDirection: "column",
                                            }}
                                          >
                                            <FaFilePdf size={40} color="red" />
                                            <p
                                              style={{
                                                fontSize: "12px",
                                                marginTop: 5,
                                              }}
                                            >
                                              {licenses[index].document.name}
                                            </p>
                                          </div>
                                        )
                                      ) : (
                                        <span
                                          className="select_license_document_box"
                                          htmlFor={`license-file-${index}`}
                                        >
                                          <FaCloudUploadAlt /> Upload document
                                        </span>
                                      )}
                                      <input
                                        id={`license-file-${index}`}
                                        type="file"
                                        accept=".pdf,.jpg,.jpeg,.png,.heic"
                                        style={{ display: "none" }}
                                        onChange={async (e) => {
                                          if (e.target.files && e.target.files.length > 0) {
                                            const file = e.target.files[0];
                                            const updated = [...licenses];
                                          const extracted_new_licenses = [
                                            ...new_licenses,
                                          ];
                                          const extracted_old_licenses = [
                                            ...old_licenses,
                                          ];
                                          const index_of_new_license =
                                            extracted_new_licenses.findIndex(
                                              (item) =>
                                                item.document_unique_id ==
                                                lic.document_unique_id
                                            );

                                          const index_of_old_license =
                                            extracted_old_licenses.findIndex(
                                              (item) =>
                                                item.document_unique_id ==
                                                lic.document_unique_id
                                            );

                                          if (!file) {
                                            updated[index].document = null;
                                            if (index_of_new_license != -1) {
                                              extracted_new_licenses[
                                                index_of_new_license
                                              ].document = null;
                                            }
                                            if (index_of_old_license != -1) {
                                              extracted_old_licenses[
                                                index_of_old_license
                                              ].document = null;
                                            }
                                            setLicenses(updated);
                                            setNewLicenses(
                                              extracted_new_licenses
                                            );
                                            setOldLicenses(
                                              extracted_old_licenses
                                            );
                                            return;
                                          }

                                          const validTypes = [
                                            "image/jpeg",
                                            "image/png",
                                            "image/jpg",
                                            "application/pdf",
                                            "image/heic",
                                          ];
                                          if (!validTypes.includes(file.type)) {
                                            toast(
                                              "Invalid file type. Only JPG, PNG, PDF, HEIC allowed",
                                              {
                                                position: "top-center",
                                                hideProgressBar: true,
                                                type: "error",
                                              }
                                            );
                                            updated[index].document = null;
                                            if (index_of_new_license != -1) {
                                              extracted_new_licenses[
                                                index_of_new_license
                                              ].document = null;
                                            }
                                            if (index_of_old_license != -1) {
                                              extracted_old_licenses[
                                                index_of_old_license
                                              ].document = null;
                                            }
                                            setLicenses(updated);
                                            setNewLicenses(
                                              extracted_new_licenses
                                            );
                                            setOldLicenses(
                                              extracted_old_licenses
                                            );
                                            return;
                                          }

                                          if (file.size > 10 * 1024 * 1024) {
                                            toast(
                                              "File size exceeds 10MB limit",
                                              {
                                                position: "top-center",
                                                hideProgressBar: true,
                                                type: "error",
                                              }
                                            );
                                            updated[index].document = null;
                                            if (index_of_new_license != -1) {
                                              extracted_new_licenses[
                                                index_of_new_license
                                              ].document = null;
                                            }
                                            if (index_of_old_license != -1) {
                                              extracted_old_licenses[
                                                index_of_old_license
                                              ].document = null;
                                            }
                                            setLicenses(updated);
                                            setNewLicenses(
                                              extracted_new_licenses
                                            );
                                            setOldLicenses(
                                              extracted_old_licenses
                                            );
                                            return;
                                          }

                                          if (
                                            file.type === "image/heic" ||
                                            file.name.endsWith(".heic")
                                          ) {
                                            try {
                                              const blob = await heic2any({
                                                blob: file,
                                                toType: "image/jpeg",
                                              });
                                              const convertedFile = new File(
                                                [blob],
                                                file.name.replace(
                                                  ".heic",
                                                  ".jpg"
                                                ),
                                                { type: "image/jpeg" }
                                              );
                                              updated[index].document =
                                                convertedFile;
                                              updated[index].status =
                                                computeStatus(updated[index]);
                                              if (index_of_new_license != -1) {
                                                extracted_new_licenses[
                                                  index_of_new_license
                                                ].document = convertedFile;
                                              }
                                              if (index_of_old_license != -1) {
                                                extracted_old_licenses[
                                                  index_of_old_license
                                                ].document = convertedFile;
                                              }
                                              setLicenses(updated);
                                              setNewLicenses(
                                                extracted_new_licenses
                                              );
                                              setOldLicenses(
                                                extracted_old_licenses
                                              );
                                            } catch (error) {
                                              toast(
                                                "Failed to process HEIC image. Please upload a JPG or PNG instead.",
                                                {
                                                  position: "top-center",
                                                  hideProgressBar: true,
                                                  type: "error",
                                                }
                                              );
                                              updated[index].document = null;
                                              if (index_of_new_license != -1) {
                                                extracted_new_licenses[
                                                  index_of_new_license
                                                ].document = null;
                                              }
                                              if (index_of_old_license != -1) {
                                                extracted_old_licenses[
                                                  index_of_old_license
                                                ].document = null;
                                              }
                                              setLicenses(updated);
                                              setNewLicenses(
                                                extracted_new_licenses
                                              );
                                              setOldLicenses(
                                                extracted_old_licenses
                                              );
                                              return;
                                            }
                                          } else {
                                            updated[index].document = file;
                                            if (index_of_new_license != -1) {
                                              extracted_new_licenses[
                                                index_of_new_license
                                              ].document = file;
                                            } else {
                                              extracted_new_licenses.push(
                                                updated[index]
                                              );
                                            }

                                            if (index_of_old_license != -1) {
                                              extracted_old_licenses.splice(
                                                index_of_old_license,
                                                1
                                              );
                                            }
                                            setLicenses(updated);
                                            setNewLicenses(
                                              extracted_new_licenses
                                            );
                                            setOldLicenses(
                                              extracted_old_licenses
                                            );
                                          }

                                          setLicenses(updated);
                                          }
                                        }}
                                      />
                                    </div>
                                    <small>
                                      File size of your documents should not
                                      exceed 10 MB
                                    </small>
                                  </div>

                                  {/* EXPIRY DATE */}
                                  <div className="mt-3">
                                    <Form.Label>License Expiry Date</Form.Label>

                                    <Form.Control
                                      type="text"
                                      value={
                                        lic?.expiry_date
                                          ? get_simple_year_date_month_str(
                                              lic.expiry_date
                                            )
                                          : ""
                                      }
                                      placeholder="Expiry Date"
                                      min={new Date()}
                                      onClick={(e) => {
                                        setSelectedLicense({
                                          ...lic,
                                          index,
                                        });
                                        setShowExpiryDateModel(true);
                                      }}
                                    />
                                    {submit && !lic?.expiry_date && (
                                      <span
                                        className="validations_err"
                                        style={errorStyle}
                                      >
                                        This field is required
                                      </span>
                                    )}
                                  </div>
                                </div>
                              );
                            })}

                            {licenses.every(
                              (lic) => lic.verified != "not_checked"
                            ) &&
                              validateLicenses() == null && (
                                <Button
                                  className="mb-3"
                                  onClick={() => {
                                    const unique_id = get_unique_id();
                                    setLicenses([
                                      ...licenses,
                                      {
                                        document_unique_id: unique_id,
                                        license_number: "",
                                        state: [],
                                        document: null,
                                        expiry_date: "",
                                        verified: "not_checked",
                                        verifying: false,
                                        file_path: "",
                                        db_id: null,
                                      },
                                    ]);
                                    setNewLicenses([
                                      ...new_licenses,
                                      {
                                        document_unique_id: unique_id,
                                        license_number: "",
                                        state: [],
                                        document: null,
                                        expiry_date: "",
                                        verified: "not_checked",
                                        verifying: false,
                                        file_path: "",
                                        db_id: null,
                                      },
                                    ]);
                                  }}
                                  style={{
                                    whiteSpace: "nowrap",
                                    textAlign: "center",
                                    minWidth: "200px",
                                    width: "auto",
                                  }}
                                >
                                  Add More License
                                </Button>
                              )}
                            {submit && validationsRes.licensesErr && (
                              <span
                                className="validations_err"
                                style={errorStyle}
                              >
                                {validationsRes.licensesErr}
                              </span>
                            )}
                          </Form.Group>
                        )}

                        <Form.Group
                          className="mt-3"
                          controlId="exampleForm.ControlInput3"
                        >
                          <Form.Label className="mb-3">
                            Supervisor's Name (if applicable)
                          </Form.Label>
                          <Form.Control
                            type="text"
                            placeholder="Supervisor's Name (if applicable)"
                            value={supervisor_name}
                            onChange={(e) => {
                              setSupervisorName(e.target.value);
                            }}
                          />
                        </Form.Group>

                        <Form.Group
                          className="mb-3"
                          controlId="exampleForm.ControlInput3"
                          style={{ position: "relative", zIndex: 5 }}
                        >
                          <Form.Label className="mb-3">
                            Select Specialty
                          </Form.Label>
                          <MultiSelect
                            options={specialityList}
                            value={speciality}
                            className="checkBoxNew"
                            onChange={setSpeciality}
                            labelledBy="Select Specialty"
                          />
                        </Form.Group>
                        {submit && validationsRes.specialityErr && (
                          <span className="validations_err" style={errorStyle}>
                            {validationsRes.specialityErr}
                          </span>
                        )}

                        <Form.Group
                          className="mb-3"
                          controlId="exampleForm.ControlInput3"
                          style={{ position: "relative", zIndex: 3 }}
                        >
                          <Form.Label className="mb-3">
                            Select Language
                          </Form.Label>
                          <MultiSelect
                            options={languageLIst}
                            value={language}
                            className="checkBoxNew"
                            onChange={setLanguage}
                            labelledBy="Select Language"
                          />
                        </Form.Group>
                        {submit && validationsRes.languageErr && (
                          <span className="validations_err" style={errorStyle}>
                            {validationsRes.languageErr}
                          </span>
                        )}
                        <Form.Group
                          className="mb-3"
                          controlId="exampleForm.ControlInput3"
                          style={{ position: "relative", zIndex: 2 }}
                        >
                          <Form.Label className="flable">
                            Qualification
                          </Form.Label>
                          <MultiSelect
                            options={certificateList}
                            value={licence}
                            className="checkBoxNew"
                            onChange={setLicence}
                            labelledBy="Select License Types"
                          />
                        </Form.Group>
                        {submit && validationsRes.licenceErr && (
                          <span className="validations_err" style={errorStyle}>
                            {validationsRes.licenceErr}
                          </span>
                        )}

                        <div className="availableBox">
                          <Form.Group
                            className="mb-4"
                            controlId="exampleForm.ControlInput3"
                          >
                            <Form.Label className="mb-3">
                              Set Your Availability
                            </Form.Label>
                            {daysArray.map((item, index) => {
                              return (
                                <div key={index} className="listItem">
                                  <Form.Check
                                    aria-label="option 1"
                                    checked={item.checked}
                                    onChange={() => {
                                      check_uncheck_fun(item.id);
                                    }}
                                  />
                                  <span
                                    className="days"
                                    style={{
                                      backgroundColor: item.checked
                                        ? ""
                                        : "gray",
                                    }}
                                  >
                                    {item.day}
                                  </span>
                                  <span className="from">From</span>
                                  <LocalizationProvider
                                    dateAdapter={AdapterDayjs}
                                  >
                                    <TimePicker
                                      label={!item.start_time && "Start Time"}
                                      value={
                                        item.start_time
                                          ? dayjs(item.start_time)
                                          : null
                                      }
                                      onChange={(newValue) =>
                                        setStartTimeFun(item.id, newValue.$d)
                                      }
                                    />
                                  </LocalizationProvider>

                                  <span className="from">To</span>
                                  <LocalizationProvider
                                    dateAdapter={AdapterDayjs}
                                  >
                                    <TimePicker
                                      label={!item.end_time && "End Time"}
                                      value={
                                        item.end_time
                                          ? dayjs(item.end_time)
                                          : null
                                      }
                                      onChange={(newValue) =>
                                        setEndTimeFun(item.id, newValue.$d)
                                      }
                                    />
                                  </LocalizationProvider>
                                </div>
                              );
                            })}
                          </Form.Group>
                          {submit && validationsRes.availabilityErr && (
                            <span
                              className="validations_err"
                              style={errorStyle}
                            >
                              {validationsRes.availabilityErr}
                            </span>
                          )}
                        </div>

                        <div className="availableBox">
                          <Form.Group
                            className="mb-4"
                            controlId="exampleForm.ControlInput3"
                          >
                            <Form.Label className="mb-3">
                              Set Pricing
                            </Form.Label>
                            {pricingArr.map((item, index) => {
                              return (
                                <div
                                  key={index}
                                  className="listItem listItem_price"
                                >
                                  <Form.Check
                                    aria-label="option 1"
                                    checked={item.checked}
                                    onChange={() => {
                                      check_uncheck_pricing_fun(item.id, index);
                                    }}
                                  />
                                  <Form.Control
                                    type="text"
                                    placeholder={`${item.time_in_min} mins`}
                                    disabled
                                  />
                                  <span className="from">Price</span>
                                  <div className="price">
                                    <span>$</span>
                                    <Form.Control
                                      ref={(ele) => {
                                        priceInputRefs.current[index] = ele;
                                      }}
                                      type="text"
                                      placeholder="0"
                                      value={item.price}
                                      onChange={(e) => {
                                        const numericValue =
                                          e.target.value.replace(/[^0-9]/g, "");
                                        setTimeValueFun(item.id, numericValue);
                                      }}
                                      // onBlur={() => {
                                      //   handleBlurOfPriceInput(item, index);
                                      // }}
                                    />
                                  </div>
                                </div>
                              );
                            })}
                          </Form.Group>
                          {submit && validationsRes.pricingErr && (
                            <span
                              className="validations_err"
                              style={errorStyle}
                            >
                              {validationsRes.pricingErr}
                            </span>
                          )}
                          <div
                            className="d-flex justify-contetent between align-items-center"
                            style={{ columnGap: 20, marginBottom: "1em" }}
                          >
                            <Button
                              className="btn btn-primary w-50"
                              onClick={() => {
                                handle_submit();
                              }}
                            >
                              Submit
                            </Button>
                            <Button
                              onClick={() => setShowDelConfirmationModal(true)}
                              className="btn btn-primary w-50"
                            >
                              Delete Account
                            </Button>
                          </div>
                        </div>
                      </div>
                    </Form>
                  </div>
                </div>

                <MyVerticallyCenteredModal
                  show={modalShow}
                  onHide={() => setModalShow(false)}
                />
                <Date_model show={showDateModel} />
                <Expiry_Date_model show={showExpiryDateModel} />
                <DeleteAccountConfirmationModal
                  show={showDelConfirmationModal}
                />
                {show_otp_modal && (
                  <Otp_model
                    show={true}
                    onHide={() => {
                      setShowOtpModal(false);
                    }}
                    verify_type="update_profile"
                    handle_profile_update={submitFun}
                  />
                )}
              </div>
            </div>
          )}
        </div>
      </section>
    </>
  );
};

export default TherapistEditProfile;

// import React, { useState, useEffect, useContext, useRef } from "react";
// import Image from "react-bootstrap/Image";
// import Form from "react-bootstrap/Form";
// import "react-phone-input-2/lib/style.css";
// import Button from "react-bootstrap/Button";
// import { Link } from "react-router-dom";
// import PlaceholderImg from "../../images/placeholder.png";
// import EditIcon from "../../images/edit.svg";
// import SuccessIcon from "../../images/success.svg";
// import Modal from "react-bootstrap/Modal";
// import BannerSection from "../../inc/BannerSection";
// import Banner from "../../images/banner.jpg";
// import TherapistSidebar from "../../inc/TherapistSidebar";
// import {
//   FaAlignLeft,
//   FaChevronDown,
//   FaChevronUp,
//   FaCloudUploadAlt,
//   FaFilePdf,
//   FaTimes,
// } from "react-icons/fa";
// import { toast } from "react-toastify";
// import { ValidationsService } from "../../../utility/services/ValidationsService";
// import ConstConfig from "../../../utility/configs/constConfig";
// import Functions from "../../../utility/services/Functions";
// import ApiService from "../../../utility/services/ApiService";
// import { AuthContext } from "../../../utility/services/AuthContext";
// import { MultiSelect } from "react-multi-select-component";
// import { LocalizationProvider } from "@mui/x-date-pickers";
// import dayjs from "dayjs";
// import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
// import { TimePicker } from "@mui/x-date-pickers/TimePicker";
// import Select from "react-dropdown-select";
// import Otp_model from "../../common/components/Otp_model";
// import Calendar from "react-calendar";
// import heic2any from "heic2any";

// const StartTime = new Date(new Date().setHours(9, 0, 0, 0)).toUTCString();
// const EndTime = new Date(new Date().setHours(18, 0, 0, 0)).toUTCString();
// const TherapistEditProfile = () => {
//   // LOGICAL VARIABLES

//   const [filterHideShow, setfilterHideShow] = useState(false);
//   const [modalShow, setModalShow] = React.useState(false);
//   const [showDelConfirmationModal, setShowDelConfirmationModal] =
//     useState(false);

//   const [validationsRes, setValidationsRes] = useState({});
//   const [submit, setSubmit] = useState(false);

//   const priceInputRefs = useRef([]);

//   const {
//     consoleService,
//     set_user_details,
//     logOut,
//     adjustSecondTimestamp,
//     formetDate,
//     calculateAge,
//     fileToBase64,
//     get_unique_id,
//   } = Functions();
//   const {
//     get_speciality,
//     get_speciality_types,
//     get_licence_list,
//     get_language_list,
//     update_therapist_profile,
//     get_states,
//     deactivate_account,
//     verify_license,
//   } = ApiService();
//   const { setLoading, user } = useContext(AuthContext);
//   const [show_otp_modal, setShowOtpModal] = useState(false);

//   const errorStyle = {
//     position: "relative",
//     top: -10,
//   };

//   // DATA VARIABLES

//   const userOldDetails = user.details;
//   const [bio, setBio] = useState(userOldDetails.bio);
//   const [daysArray, setDaysArray] = useState([...userOldDetails.availability]);

//   const [pricingArr, setPricingArr] = useState([...userOldDetails.pricing]);

//   const [firstName, setFirstName] = useState(userOldDetails.first_name);
//   const [lastName, setLastName] = useState(userOldDetails.last_name);
//   const [dob, setDob] = useState(userOldDetails.dob);
//   const [date_to_send, setDateToSend] = useState(userOldDetails.dob);
//   const [email, setEmail] = useState(userOldDetails.email);

//   const isOldUser =
//     !userOldDetails.licenses ||
//     (Array.isArray(userOldDetails.licenses) &&
//       userOldDetails.licenses.length === 0);

//   const [check_license_cond_for_old_user, setCheckLicenseCondForOldUser] =
//     useState(false);

//   // State to track if old user wants to verify license
//   const [showLicenseFormForOldUser, setShowLicenseFormForOldUser] =
//     useState(false);
//   // Multiple licenses state management

//   const [licenses, setLicenses] = useState([]);

//   const [old_licenses, setOldLicenses] = useState(() => []);

//   const [new_licenses, setNewLicenses] = useState([]);
//   const [isAnyLicenseVerifying, setIsAnyLicenseVerifying] = useState(false);
//   const [supervisor_name, setSupervisorName] = useState(
//     userOldDetails.supervisor_name ? userOldDetails.supervisor_name : ""
//   );
//   const [speciality, setSpeciality] = useState([]);
//   const [profile_img, setProfileImg] = useState("");
//   const [state, setState] = useState([
//     {
//       label: userOldDetails.state,
//       value: userOldDetails.state_id,
//     },
//   ]);
//   const [stateListFocus, setStateListFocus] = useState(false);
//   const [language, setLanguage] = useState([]);
//   const [imgPreview, setImgPreview] = useState(
//     userOldDetails.profile_img
//       ? `${ConstConfig.IMAGE_URL}/${userOldDetails.profile_img}`
//       : PlaceholderImg
//   );

//   const [licence, setLicence] = useState([]);
//   const [certificateList, setLicenceList] = useState([]);
//   const [languageLIst, setLanguageList] = useState([]);
//   const [specialityList, setSpecialityList] = useState([]);
//   const [statesList, setStatesList] = useState([]);

//   const [showDateModel, setShowDateModel] = useState(false);
//   const [showExpiryDateModel, setShowExpiryDateModel] = useState(false);
//   const [selected_license, setSelectedLicense] = useState({});
//   const min_thirty_min_amt = 39;
//   const min_sixty_min_amt = 59;

//   const findThirtyMinEntry = pricingArr.findIndex(
//     (item) => item.time_in_min == 30
//   );
//   const findSixtyMinEntry = pricingArr.findIndex(
//     (item) => item.time_in_min == 60
//   );
//   const ThirtyMinCond =
//     pricingArr[findThirtyMinEntry].price >= min_thirty_min_amt;
//   const SixtyMinCond = pricingArr[findSixtyMinEntry].price >= min_sixty_min_amt;

//   // USE EFFECT

//   useEffect(() => {
//     fetch_lists();
//     set_licenses_function();
//   }, []);

//   useEffect(() => {
//     validationsResFun();
//   }, [
//     firstName,
//     dob,
//     email,
//     speciality,
//     language,
//     licence,
//     daysArray,
//     pricingArr,
//     bio,
//     licenses,
//     supervisor_name,
//   ]);

//   // FUNCTIONS

//   const onhandle = () => setModalShow(false);
//   const sideBarHide = () => {
//     setfilterHideShow(!filterHideShow);
//   };

//   async function set_licenses_function() {
//     if (
//       userOldDetails.licenses &&
//       Array.isArray(userOldDetails.licenses) &&
//       userOldDetails.licenses.length > 0
//     ) {
//       const details = [];
//       for (let license of userOldDetails.licenses) {
//         const file_path = license.file_path
//           ? `${ConstConfig.IMAGE_URL}/${license.file_path}`
//           : null;
//         const modify_data = {
//           document_unique_id: get_unique_id(),
//           license_number: license.license_number || "",
//           state: license.state_name
//             ? [{ label: license.state_name, value: license.state }]
//             : [],
//           document: license.file_path
//             ? await urlToFile(
//                 file_path,
//                 file_path.split("/").pop(), // fileName
//                 file_path.includes(".pdf") ? "application/pdf" : "image/jpeg" // mimeType
//               )
//             : null,
//           expiry_date: license.expiry_date
//             ? formetDate(license.expiry_date)
//             : "",
//           verified: license.verified
//             ? license.verified == "verified"
//               ? license.verified
//               : "unverified"
//             : "unverified",
//           verifying: false,
//           file_path: license.file_path,
//         };
//         details.push(modify_data);
//       }

//       const details_for_old_licenses = details.map((lic) => {
//         delete lic._id;
//         return lic;
//       });

//       setLicenses([...details]);
//       setOldLicenses([...details_for_old_licenses]);
//     }
//     // Fallback to old single license format
//     else if (userOldDetails.license_number) {
//       const certificate = userOldDetails.certificates[0];
//       const file_path = `${ConstConfig.IMAGE_URL}/${certificate}`;
//       const details = [
//         {
//           document_unique_id: get_unique_id(),
//           license_number: userOldDetails.license_number || "",
//           state: userOldDetails.state
//             ? [{ label: userOldDetails.state, value: userOldDetails.state_id }]
//             : [],
//           document: await urlToFile(
//             file_path,
//             file_path.split("/").pop(), // fileName
//             file_path.includes(".pdf") ? "application/pdf" : "image/jpeg" // mimeType
//           ),
//           expiry_date: "",
//           verified: "not_checked", // Set to false so user can verify
//           verifying: false,
//           file_path: certificate ? certificate : "",
//         },
//       ];
//       const details_for_old_licenses = details.map((lic) => {
//         delete lic._id;
//         return lic;
//       });
//       setLicenses([...details]);
//       setOldLicenses([...details_for_old_licenses]);
//     }
//     // Default empty license for new users
//     else {
//       const details = [
//         {
//           document_unique_id: get_unique_id(),
//           license_number: "",
//           state: [],
//           document: null,
//           expiry_date: "",
//           verified: "not_checked",
//           verifying: false,
//           file_path: "",
//         },
//       ];
//       const details_for_old_licenses = details.map((lic) => {
//         delete lic._id;
//         return lic;
//       });
//       setLicenses([...details]);
//       setOldLicenses([...details_for_old_licenses]);
//     }
//   }

//   function validationsResFun() {
//     setValidationsRes(
//       ValidationsService({
//         firstName,
//         dob,
//         email,
//         speciality,
//         licence,
//         language,
//         availability: daysArray,
//         pricing: pricingArr,
//         bio,
//         licenses,
//         supervisor_name,
//       })
//     );
//   }

//   async function fetch_lists() {
//     setLoading(true);
//     try {
//       const res = await get_speciality_types();
//       const licence_res = await get_licence_list();
//       const language_res = await get_language_list();
//       const states_res = await get_states();
//       if (
//         res.status === 1 &&
//         licence_res.status === 1 &&
//         language_res.status === 1 &&
//         states_res.status === 1
//       ) {
//         const typeId = res.data[0]._id;
//         const list_res = await get_speciality(typeId);
//         const modifiedRes = licence_res.data.map((item) => {
//           return { label: item.title, value: item._id };
//         });
//         const modifiedLanguageRes = language_res.data.map((item) => {
//           return { label: item.title, value: item._id };
//         });
//         const old_licence = [];
//         const old_languages = [];
//         licence_res.data.forEach((mainItem) => {
//           const isFind = userOldDetails.selected_certificates_id.some(
//             (item) => item == mainItem._id
//           );
//           if (isFind) {
//             old_licence.push({ label: mainItem.title, value: mainItem._id });
//           }
//         });
//         language_res.data.forEach((mainItem) => {
//           const isFind = userOldDetails.language_id.some(
//             (item) => item == mainItem._id
//           );
//           if (isFind) {
//             old_languages.push({ label: mainItem.title, value: mainItem._id });
//           }
//         });
//         const modified_states_list = states_res.data.map((item) => {
//           return { label: item.title, value: item._id };
//         });
//         setStatesList(modified_states_list);
//         setLicence(old_licence);
//         setLanguage(old_languages);
//         setLicenceList([...modifiedRes]);
//         setLanguageList([...modifiedLanguageRes]);
//         if (list_res.status == 1) {
//           const old_specialities = [];
//           list_res.data.forEach((mainItem) => {
//             const isFind = userOldDetails.speciality_id.some(
//               (item) => item == mainItem._id
//             );
//             if (isFind) {
//               old_specialities.push({
//                 label: mainItem.title,
//                 value: mainItem._id,
//               });
//             }
//           });
//           const modifiedRes = list_res.data.map((item) => {
//             return { label: item.title, value: item._id };
//           });
//           setSpeciality(old_specialities);
//           setSpecialityList([...modifiedRes]);
//           setLoading(false);
//         }
//       }
//     } catch (err) {
//       setLoading(false);
//       consoleService("Error in fetch lists function = ", err);
//     }
//   }

//   const select_profile_img = async (files) => {
//     try {
//       if (files.length > 0) {
//         const file = files[0];
//         const imageTypeRegex = /image\/(jpg|jpeg|png|heic)/gm;
//         const isMatch = file.type.match(imageTypeRegex);
//         if (isMatch) {
//           if (file.type === "image/heic" || file.name.endsWith(".heic")) {
//             try {
//               const blob = await heic2any({
//                 blob: file,
//                 toType: "image/jpeg",
//               });
//               const convertedFile = new File(
//                 [blob],
//                 file.name.replace(".heic", ".jpg"),
//                 { type: "image/jpeg" }
//               );
//               setImgPreview(URL.createObjectURL(convertedFile));
//               setProfileImg(convertedFile);
//             } catch (error) {
//               toast(
//                 "Failed to process HEIC image. Please upload a JPG or PNG instead.",
//                 {
//                   position: "top-center",
//                   hideProgressBar: true,
//                   type: "error",
//                 }
//               );
//               return;
//             }
//           } else {
//             setImgPreview(URL.createObjectURL(file));
//             setProfileImg(file);
//           }
//         } else {
//           toast("Please select a file in JPG, PNG, HEIC, or JPEG format.", {
//             position: "top-center",
//             hideProgressBar: true,
//             type: "error",
//           });
//         }
//       }
//     } catch (err) {
//       consoleService("error in select_profile_img =", err);
//     }
//   };

//   const check_uncheck_fun = (id) => {
//     const check = daysArray.some((item) => {
//       return item.id == id && item.checked == false;
//     });

//     const findEntry = daysArray.find((item) => item.id == id);

//     if (check) {
//       const startTime = new Date(findEntry.start_time);
//       const end_time = new Date(findEntry.end_time);
//       const time1 = startTime.getHours() * 60 + startTime.getMinutes();
//       const time2 = end_time.getHours() * 60 + end_time.getMinutes();
//       const condition = time1 < time2;
//       if (!findEntry.start_time || !findEntry.end_time) {
//         const newArray = daysArray.map((item) => {
//           if (item.id == id) {
//             item.checked = check;
//             if (!item.start_time) {
//               item.start_time = StartTime;
//             }
//             if (!item.end_time) {
//               item.end_time = EndTime;
//             }
//             return item;
//           } else {
//             return item;
//           }
//         });
//         setDaysArray([...newArray]);
//       } else {
//         if (condition) {
//           const newArray = daysArray.map((item) => {
//             if (item.id == id) {
//               item.checked = check;
//               return item;
//             } else {
//               return item;
//             }
//           });
//           setDaysArray([...newArray]);
//         } else {
//           toast("Incorrect time schedule.", {
//             position: "top-center",
//             hideProgressBar: true,
//             type: "error",
//           });
//         }
//       }
//     } else {
//       const newArray = daysArray.map((item) => {
//         if (item.id == id) {
//           item.start_time = "";
//           item.end_time = "";
//           item.checked = check;
//           return item;
//         } else {
//           return item;
//         }
//       });
//       setDaysArray([...newArray]);
//     }
//   };

//   async function urlToFile(url, fileName, mimeType) {
//     if (!url) {
//       return null;
//     }

//     const response = await fetch(url);
//     const blob = await response.blob();
//     const file = new File([blob], fileName, { type: mimeType });

//     return file;
//   }

//   const setStartTimeFun = (id, time) => {
//     const Time = new Date(time);
//     const newArray = daysArray.map((item) => {
//       if (item.id == id) {
//         item.start_time = Time.toUTCString();
//         return item;
//       } else {
//         return item;
//       }
//     });
//     setDaysArray([...newArray]);
//   };

//   const setEndTimeFun = (id, time) => {
//     const Time = new Date(time);
//     const newArray = daysArray.map((item) => {
//       if (item.id == id) {
//         item.end_time = Time.toUTCString();
//         return item;
//       } else {
//         return item;
//       }
//     });
//     setDaysArray([...newArray]);
//   };

//   const setTimeValueFun = (id, value) => {
//     const newArray = pricingArr.map((item) => {
//       if (item.id == id) {
//         item.price = value.toString();
//         return item;
//       } else {
//         return item;
//       }
//     });
//     setPricingArr([...newArray]);
//   };

//   const MInCond_toast = (amt) => {
//     toast(`Price should be minimum ${amt}.`, {
//       position: "top-center",
//       hideProgressBar: true,
//       type: "error",
//     });
//   };

//   const check_uncheck_pricing_fun = (id, index) => {
//     const check = pricingArr.some((item) => {
//       return item.id == id && item.checked == false;
//     });
//     const condition = pricingArr.some((item) => {
//       return item.id == id && item.price != "" && Number(item.price) > 0;
//     });
//     if (check) {
//       if (condition) {
//         if (index == findThirtyMinEntry && !ThirtyMinCond) {
//           MInCond_toast(min_thirty_min_amt);
//           return;
//         } else if (index == findSixtyMinEntry && !SixtyMinCond) {
//           MInCond_toast(min_sixty_min_amt);
//           return;
//         }
//         const newArray = pricingArr.map((item) => {
//           if (item.id == id) {
//             item.checked = check;
//             return item;
//           } else {
//             return item;
//           }
//         });
//         setPricingArr([...newArray]);
//       } else {
//         if (index == findThirtyMinEntry) {
//           const newArray = pricingArr.map((item) => {
//             if (item.id == id) {
//               item.checked = check;
//               item.price = min_thirty_min_amt;
//               return item;
//             } else {
//               return item;
//             }
//           });
//           setPricingArr([...newArray]);
//         } else if (index == findSixtyMinEntry) {
//           const newArray = pricingArr.map((item) => {
//             if (item.id == id) {
//               item.checked = check;
//               item.price = min_sixty_min_amt;
//               return item;
//             } else {
//               return item;
//             }
//           });
//           setPricingArr([...newArray]);
//         }
//       }
//     } else {
//       const newArray = pricingArr.map((item) => {
//         if (item.id == id) {
//           item.checked = check;
//           return item;
//         } else {
//           return item;
//         }
//       });
//       setPricingArr([...newArray]);
//     }
//   };

//   function checkAvailability() {
//     let errorDay = "";
//     const condition = daysArray.some((findEntry) => {
//       if (
//         findEntry.checked &&
//         findEntry.startTime != "" &&
//         findEntry.end_time != ""
//       ) {
//         const startTime = new Date(findEntry.start_time);
//         const end_time = new Date(findEntry.end_time);
//         const time1 = startTime.getHours() * 60 + startTime.getMinutes();
//         const time2 = end_time.getHours() * 60 + end_time.getMinutes();
//         const condition = time1 < time2;
//         if (!condition) {
//           errorDay = findEntry.day;
//         }
//         return !condition;
//       } else {
//         return false;
//       }
//     });

//     const isAvailabilityOK = !condition;

//     return { isAvailabilityOK, errorDay };
//   }

//   const verifyLicense = async (index) => {
//     const updatedLicenses = [...licenses];

//     const license = updatedLicenses[index];
//     const extracted_new_licenses = [...new_licenses];
//     const extracted_old_licenses = [...old_licenses];
//     const index_of_new_license = extracted_new_licenses.findIndex(
//       (lic) => license.document_unique_id == lic.document_unique_id
//     );
//     const index_of_old_license = extracted_old_licenses.findIndex(
//       (lic) => license.document_unique_id == lic.document_unique_id
//     );
//     // Check for duplicate license numbers
//     const isDuplicate = licenses.some(
//       (lic, i) =>
//         i !== index &&
//         lic.license_number.trim() &&
//         lic.license_number.toUpperCase() ===
//           license.license_number.toUpperCase()
//     );

//     if (isDuplicate) {
//       toast(
//         "This license number is already used. Please enter a different license number.",
//         {
//           position: "top-center",
//           hideProgressBar: true,
//           type: "error",
//         }
//       );
//       return;
//     }

//     license.verifying = true;
//     if (index_of_new_license != -1) {
//       extracted_new_licenses[index_of_new_license].verifying = true;
//     }
//     if (index_of_old_license != -1) {
//       extracted_old_licenses[index_of_old_license].verifying = true;
//     }
//     setIsAnyLicenseVerifying(true);
//     setLicenses([...updatedLicenses]);
//     setNewLicenses([...extracted_new_licenses]);
//     setOldLicenses([...extracted_old_licenses]);

//     try {
//       const base64File = await fileToBase64(license.document);
//       const requestData = {
//         license_number: license.license_number,
//         state: license.state[0].label,
//         file: base64File,
//       };

//       const response = await verify_license(requestData);

//       if (response.status === 1) {
//         license.verified = "verified";
//         license.expiry_date = response.data.expiry_date;
//         if (index_of_new_license != -1) {
//           extracted_new_licenses[index_of_new_license].verified = "verified";
//           extracted_new_licenses[index_of_new_license].expiry_date =
//             response.data.expiry_date;
//         }
//         if (index_of_old_license != -1) {
//           extracted_old_licenses[index_of_old_license].verified = "verified";
//           extracted_old_licenses[index_of_old_license].expiry_date =
//             response.data.expiry_date;
//         }
//         setLicenses([...updatedLicenses]);
//         setNewLicenses([...extracted_new_licenses]);
//         setOldLicenses([...extracted_old_licenses]);
//       } else {
//         license.verified = "unverified";
//         toast(response.message || "Verification failed", {
//           position: "top-center",
//           hideProgressBar: true,
//           type: "info",
//           style: {
//             backgroundColor: "#1D7E7C",
//             color: "white",
//           },
//         });
//       }
//     } catch (error) {
//       consoleService("License verification error:", error);
//       license.verified = "unverified";
//       if (index_of_new_license != -1) {
//         extracted_new_licenses[index_of_new_license].verified = "unverified";
//       }
//       if (index_of_old_license != -1) {
//         extracted_old_licenses[index_of_old_license].verified = "unverified";
//       }
//       setLicenses([...updatedLicenses]);
//       setNewLicenses([...extracted_new_licenses]);
//       setOldLicenses([...extracted_old_licenses]);
//       toast("Server error occurred", {
//         position: "top-center",
//         hideProgressBar: true,
//         type: "error",
//       });
//     } finally {
//       license.verifying = false;
//       if (index_of_new_license != -1) {
//         extracted_new_licenses[index_of_new_license].verifying = false;
//       }
//       if (index_of_old_license != -1) {
//         extracted_old_licenses[index_of_old_license].verifying = false;
//       }
//       setNewLicenses([...extracted_new_licenses]);
//       setOldLicenses([...extracted_old_licenses]);
//       setIsAnyLicenseVerifying(false);
//       setLicenses([...updatedLicenses]);
//     }
//   };

//   const validateLicenses = () => {
//     for (const lic of licenses) {
//       if (
//         !lic.license_number ||
//         !lic.state.length ||
//         !lic.document ||
//         !lic.expiry_date
//       ) {
//         return "All license fields are required";
//       }
//     }
//     return null;
//   };
//   const validateLicensesForExpiryDate = () => {
//     for (const lic of licenses) {
//       if (!lic.license_number || !lic.state.length || !lic.document) {
//         return "All license fields are required";
//       }
//     }
//     return null;
//   };

//   const submitFun = async (otp, setOtpLoading) => {
//     setLoading(true);

//     try {
//       const formData = new FormData();
//       formData.append("first_name", firstName);
//       formData.append("last_name", lastName);
//       formData.append("dob", date_to_send);
//       formData.append("email", email);
//       formData.append("otp", otp);
//       if (profile_img) {
//         formData.append("profile_img", profile_img);
//       }

//       formData.append(
//         "speciality_id",
//         JSON.stringify(speciality.map((item) => item.value))
//       );

//       formData.append(
//         "certificates",
//         JSON.stringify(licence.map((item) => item.value))
//       );
//       formData.append("bio", bio);
//       formData.append(
//         "language",
//         JSON.stringify(language.map((item) => item.value))
//       );
//       // Send licenses array instead of single license_number
//       const licensesData = new_licenses.map((lic, index) => ({
//         license_number: lic.license_number,
//         state: lic?.state?.length > 0 ? lic.state[0].value : "",
//         file_path: "",
//         expiry_date: lic.expiry_date,
//         verified: lic.verified == "not_checked" ? "unverified" : lic.verified,
//       }));
//       const old_licenses_data = old_licenses.map((lic, index) => {
//         const item = { ...lic };
//         item.state = lic?.state?.length > 0 ? lic.state[0].value : "";

//         return item;
//       });

//       if (isOldUser) {
//         if (check_license_cond_for_old_user) {
//           formData.append("new_licenses", JSON.stringify(licensesData));
//           formData.append("licenses", JSON.stringify(old_licenses_data));
//         } else {
//           formData.append("new_licenses", JSON.stringify([]));
//           formData.append("licenses", JSON.stringify([]));
//         }
//       } else {
//         formData.append("new_licenses", JSON.stringify(licensesData));
//         formData.append("licenses", JSON.stringify(old_licenses_data));
//       }

//       // Append license documents
//       new_licenses.forEach((lic, index) => {
//         if (lic.document) {
//           formData.append(`license_document_${index}`, lic.document);
//         }
//       });

//       formData.append("supervisor_name", supervisor_name);

//       const resolvedSecondStampsDaysArr = daysArray.map((obj) => {
//         const firstStamp = obj.start_time;
//         const secondStamp = obj.end_time;
//         if (obj.checked) {
//           const newObj = obj;
//           newObj.start_time = adjustSecondTimestamp(
//             firstStamp,
//             secondStamp
//           ).firstDate;
//           newObj.end_time = adjustSecondTimestamp(
//             firstStamp,
//             secondStamp
//           ).secondDate;
//           return newObj;
//         } else {
//           return obj;
//         }
//       });

//       const final_availability = resolvedSecondStampsDaysArr.map((item) => {
//         if (item.checked) {
//           return item;
//         } else {
//           item.start_time = "";
//           item.end_time = "";
//           return item;
//         }
//       });
//       formData.append("availability", JSON.stringify(final_availability));
//       formData.append("pricing", JSON.stringify(pricingArr));

//       const res = await update_therapist_profile(formData);
//       if (res.status === 1) {
//         await set_user_details();
//         setShowOtpModal(false);
//         setLoading(false);
//         if (setOtpLoading != undefined) {
//           setOtpLoading(false);
//         }
//         setSubmit(false);

//         toast("Profile updated successfully", {
//           position: "top-center",
//           hideProgressBar: true,
//           type: "success",
//         });
//       } else {
//         setLoading(false);
//         if (setOtpLoading != undefined) {
//           setOtpLoading(false);
//         }
//         toast(res.message, {
//           position: "top-center",
//           hideProgressBar: true,
//           type: "error",
//         });
//       }
//     } catch (err) {
//       setLoading(false);
//       consoleService("Error in submit function = ", err);
//     }
//   };

//   const handle_submit = async () => {
//     if (!(calculateAge(dob) >= 12))
//       return toast("You must be above 12 years of age to register.", {
//         position: "top-center",
//         hideProgressBar: true,
//         type: "error",
//       });
//     setSubmit(true);

//     if (isOldUser) {
//       if (check_license_cond_for_old_user) {
//         const licenseValidationError = validateLicenses();
//         if (licenseValidationError) {
//           toast(licenseValidationError, {
//             position: "top-center",
//             hideProgressBar: true,
//             type: "error",
//           });
//           return;
//         }
//       }
//     } else {
//       const licenseValidationError = validateLicenses();
//       if (licenseValidationError) {
//         toast(licenseValidationError, {
//           position: "top-center",
//           hideProgressBar: true,
//           type: "error",
//         });
//         return;
//       }
//     }

//     if (
//       !validationsRes.firstNameErr &&
//       !validationsRes.dobErr &&
//       !validationsRes.emailErr &&
//       !validationsRes.specialityErr &&
//       !validationsRes.licenceErr &&
//       !validationsRes.availabilityErr &&
//       !validationsRes.languageErr &&
//       !validationsRes.bioErr &&
//       !validationsRes.licensesErr &&
//       !validationsRes.pricingErr
//     ) {
//       const { isAvailabilityOK, errorDay } = checkAvailability();
//       let Day = "";
//       switch (errorDay) {
//         case "Mon":
//           Day = "Monday";
//           break;
//         case "Tue":
//           Day = "Tuesday";
//           break;
//         case "Wed":
//           Day = "Wednesday";
//           break;
//         case "Thu":
//           Day = "Thursday";
//           break;
//         case "Fri":
//           Day = "Friday";
//           break;
//         case "Sat":
//           Day = "Saturday";
//           break;
//         case "Sun":
//           Day = "Sunday";
//           break;
//       }
//       if (!isAvailabilityOK)
//         return toast("Invaild entry found on " + Day, {
//           position: "top-center",
//           hideProgressBar: true,
//           type: "error",
//         });

//       if (
//         (pricingArr[findThirtyMinEntry].checked && !ThirtyMinCond) ||
//         (pricingArr[findSixtyMinEntry].checked && !SixtyMinCond)
//       ) {
//         return pricingArr[findThirtyMinEntry].checked && !ThirtyMinCond
//           ? MInCond_toast(min_thirty_min_amt)
//           : MInCond_toast(min_sixty_min_amt);
//       }

//       const phone = userOldDetails.phone;
//       if (phone && phone.toString().trim()) {
//         setShowOtpModal(true);
//       } else {
//         submitFun(null);
//       }
//     } else {
//       toast("Some fields are missing.", {
//         position: "top-center",
//         hideProgressBar: true,
//         type: "error",
//       });
//     }
//   };

//   const handleBlurOfPriceInput = (item, index) => {
//     if (
//       item.time_in_min == 30 &&
//       item.checked &&
//       priceInputRefs.current[index].value < min_thirty_min_amt
//     ) {
//       MInCond_toast(min_thirty_min_amt);
//       priceInputRefs.current[index].focus();
//     } else if (
//       item.time_in_min == 60 &&
//       item.checked &&
//       priceInputRefs.current[index].value < min_sixty_min_amt
//     ) {
//       MInCond_toast(min_sixty_min_amt);
//       priceInputRefs.current[index].focus();
//     }
//   };

//   // NESTED COMPONENTS

//   function Date_model(props) {
//     const [selectedDate, setSelectedDate] = useState(
//       dob ? new Date(dob) : new Date(1940, 0, 1)
//     );
//     return (
//       <Modal
//         {...props}
//         size="md"
//         className="modalregs"
//         aria-labelledby="contained-modal-title-vcenter"
//         centered
//         onHide={() => {
//           setSelectedDate(new Date(dob));
//           setShowDateModel(false);
//         }}
//       >
//         <Modal.Body className="text-left">
//           <section className="pb-4 pt-2 packagebox packagebox_book">
//             <div className="container">
//               <div className="row">
//                 <div className="col-md-12">
//                   <h2>Select Date</h2>
//                   <Calendar
//                     onChange={(date) => {
//                       setSelectedDate(new Date(date));
//                     }}
//                     value={selectedDate}
//                     minDate={new Date(1940, 0, 1)}
//                     maxDate={new Date()}
//                     tileClassName="calendar_tiles"
//                   />
//                 </div>
//               </div>
//             </div>
//           </section>
//         </Modal.Body>
//         <Modal.Footer>
//           <Button
//             as={Link}
//             onClick={(e) => {
//               e.preventDefault();
//               setDob(
//                 `${selectedDate.getFullYear()}/${
//                   selectedDate.getMonth() + 1
//                 }/${selectedDate.getDate()}`
//               );
//               setDateToSend(selectedDate);
//               setShowDateModel(false);
//             }}
//           >
//             Done
//           </Button>
//         </Modal.Footer>
//       </Modal>
//     );
//   }

//   function Expiry_Date_model(props) {
//     const lic = selected_license;
//     const index = lic.index;
//     const [selectedDate, setSelectedDate] = useState(
//       lic.expiry_date
//         ? new Date(lic.expiry_date).toISOString().split("T")[0]
//         : new Date()
//     );
//     return (
//       <Modal
//         {...props}
//         size="md"
//         className="modalregs"
//         aria-labelledby="contained-modal-title-vcenter"
//         centered
//         onHide={() => {
//           setSelectedDate(new Date(lic.expiry_date));
//           setShowExpiryDateModel(false);
//         }}
//       >
//         <Modal.Body className="text-left">
//           <section className="pb-4 pt-2 packagebox packagebox_book">
//             <div className="container">
//               <div className="row">
//                 <div className="col-md-12">
//                   <h2>Select Date</h2>
//                   <Calendar
//                     onChange={(date) => {
//                       setSelectedDate(new Date(date));
//                     }}
//                     value={selectedDate}
//                     minDate={new Date()}
//                     tileClassName="calendar_tiles"
//                   />
//                 </div>
//               </div>
//             </div>
//           </section>
//         </Modal.Body>
//         <Modal.Footer>
//           <Button
//             as={Link}
//             onClick={(e) => {
//               e.preventDefault();
//               const updated = [...licenses];
//               const extracted_new_licenses = [...new_licenses];
//               const extracted_old_licenses = [...old_licenses];
//               const index_of_new_license = extracted_new_licenses.findIndex(
//                 (license) =>
//                   license.document_unique_id == lic.document_unique_id
//               );
//               const index_of_old_license = extracted_old_licenses.findIndex(
//                 (license) =>
//                   license.document_unique_id == lic.document_unique_id
//               );
//               const utcDate = new Date(
//                 Date.UTC(
//                   selectedDate.getFullYear(),
//                   selectedDate.getMonth(),
//                   selectedDate.getDate()
//                 )
//               );
//               updated[index].expiry_date = utcDate.toISOString().split("T")[0];
//               if (index_of_new_license != -1) {
//                 extracted_new_licenses[index_of_new_license].expiry_date =
//                   utcDate.toISOString().split("T")[0];
//               }
//               if (index_of_old_license != -1) {
//                 extracted_old_licenses[index_of_old_license].expiry_date =
//                   utcDate.toISOString().split("T")[0];
//               }
//               setLicenses(updated);
//               setNewLicenses(extracted_new_licenses);
//               setOldLicenses(extracted_old_licenses);
//               setShowExpiryDateModel(false);
//             }}
//           >
//             Done
//           </Button>
//         </Modal.Footer>
//       </Modal>
//     );
//   }

//   function MyVerticallyCenteredModal(props) {
//     return (
//       <Modal
//         {...props}
//         size="sm"
//         className="modalSuccess"
//         aria-labelledby="contained-modal-title-vcenter"
//         centered
//       >
//         <Modal.Body>
//           <Image src={SuccessIcon} alt="" />
//           <h4>Success</h4>
//           <p>Your account has been created successfully!</p>
//         </Modal.Body>
//         <Modal.Footer>
//           <Button as={Link} onClick={onhandle}>
//             OK
//           </Button>
//         </Modal.Footer>
//       </Modal>
//     );
//   }

//   const DeleteAccountConfirmationModal = (props) => {
//     const deleteAccount = async () => {
//       try {
//         setShowDelConfirmationModal(false);
//         setLoading(true);
//         const res = await deactivate_account();
//         if (res.status === 1) {
//           setLoading(false);
//           logOut();
//         }
//       } catch (err) {
//         consoleService("error in delete Account function = ", err);
//       }
//     };

//     return (
//       <Modal
//         {...props}
//         size="sm"
//         className="modalSuccess modalBtn"
//         aria-labelledby="contained-modal-title-vcenter"
//         centered
//       >
//         <Modal.Body>
//           <h4>Are you Sure?</h4>
//           <p className="mb-1">
//             To delete your account.You can reactivate your account if you log in
//             within 7 days. After seven days, your account will be permanently
//             deleted.
//           </p>
//         </Modal.Body>
//         <Modal.Footer>
//           <Button
//             as={Link}
//             onClick={() => {
//               setShowDelConfirmationModal(false);
//             }}
//           >
//             No
//           </Button>
//           <Button
//             // as={Link}
//             onClick={() => {
//               deleteAccount();
//             }}
//           >
//             Delete
//           </Button>
//         </Modal.Footer>
//       </Modal>
//     );
//   };

//   // MAIN RETURN

//   return (
//     <>
//       <div className="breadHidePhone">
//         <BannerSection banner={Banner} name={"Home"} title={"Edit Profile"} />
//       </div>
//       <section className="py-5 useraccount bg-light_dash profCheckbox">
//         <div className="container">
//           {licenses.length > 0 && (
//             <div className="row">
//               <div
//                 className={`col-xl-3 col-md-4 ${
//                   filterHideShow ? "leftShow" : "leftHide"
//                 }`}
//               >
//                 <TherapistSidebar />
//               </div>
//               <div className="col-xl-9 col-md-8 fulltabBox">
//                 <div className="filterBox">
//                   <Link className="filterIcon" onClick={sideBarHide}>
//                     <FaAlignLeft />
//                   </Link>
//                 </div>
//                 <div className="dashboard-widg-bar d-block">
//                   <div className="dashboard_body">
//                     <h4 className="mb-4 ft-medium">Personal Information</h4>
//                     <Form>
//                       <div className="loginBox loginUpdateBox">
//                         <div className="userImg">
//                           <Image
//                             src={imgPreview ? imgPreview : PlaceholderImg}
//                             className="userImage"
//                             alt=""
//                           />
//                           <div>
//                             <Image src={EditIcon} className="editIcon" alt="" />
//                             <input
//                               type="file"
//                               accept="image/jpg, image/jpeg, image/png, image/heic"
//                               className="edit_img"
//                               multiple={false}
//                               onChange={(e) => {
//                                 select_profile_img(e.target.files);
//                               }}
//                             />
//                           </div>
//                         </div>

//                         <Form.Control
//                           type="text"
//                           placeholder="First Name"
//                           value={firstName}
//                           onChange={(e) => setFirstName(e.target.value)}
//                         />
//                         {submit && validationsRes.firstNameErr && (
//                           <span className="validations_err" style={errorStyle}>
//                             {validationsRes.firstNameErr}
//                           </span>
//                         )}
//                         <Form.Control
//                           type="text"
//                           placeholder="Last Name"
//                           value={lastName}
//                           onChange={(e) => setLastName(e.target.value)}
//                         />

//                         <Form.Control
//                           className="mb-3"
//                           type="text"
//                           placeholder="D.O.B."
//                           value={dob && formetDate(dob)}
//                           onClick={() => {
//                             setShowDateModel(true);
//                           }}
//                         />
//                         {!submit && !validationsRes.dobErr && (
//                           <small>
//                             You must be above 12 years of age to register
//                           </small>
//                         )}
//                         {submit && validationsRes.dobErr && (
//                           <span className="validations_err" style={errorStyle}>
//                             {validationsRes.dobErr}
//                           </span>
//                         )}
//                         <Form.Control
//                           type="text"
//                           placeholder="Email Address"
//                           value={email}
//                           onChange={(e) => setEmail(e.target.value)}
//                         />
//                         {submit && validationsRes.emailErr && (
//                           <span className="validations_err" style={errorStyle}>
//                             {validationsRes.emailErr}
//                           </span>
//                         )}
//                         <Form.Control
//                           type="text"
//                           as={"textarea"}
//                           rows={4}
//                           style={{
//                             height: "auto",
//                           }}
//                           placeholder="Enter Your Bio"
//                           value={bio}
//                           onChange={(e) => setBio(e.target.value)}
//                         />
//                         {submit && validationsRes.bioErr && (
//                           <span className="validations_err" style={errorStyle}>
//                             {validationsRes.bioErr}
//                           </span>
//                         )}

//                         {isOldUser && !showLicenseFormForOldUser ? (
//                           <React.Fragment>
//                             <Form.Group
//                               className="mt-3"
//                               controlId="exampleForm.ControlInput3"
//                             >
//                               <div className="d-flex justify-content-between align-items-center mb-3">
//                                 <Form.Label className="mb-0">
//                                   License Number
//                                 </Form.Label>
//                                 <span
//                                   style={{
//                                     color: "#1D7E7C",
//                                     cursor: "pointer",
//                                     fontWeight: "bold",
//                                     fontSize: "15px",
//                                   }}
//                                   onClick={() => {
//                                     setShowLicenseFormForOldUser(true);
//                                     setCheckLicenseCondForOldUser(true);
//                                     setNewLicenses([...old_licenses]);
//                                     setOldLicenses([]);
//                                   }}
//                                 >
//                                   Verify your license
//                                 </span>
//                               </div>
//                               <Form.Control
//                                 type="text"
//                                 placeholder="License Number"
//                                 value={userOldDetails.license_number}
//                                 disabled={true}
//                                 style={{ textTransform: "uppercase" }}
//                               />
//                             </Form.Group>

//                             <Form.Group
//                               className="mt-3"
//                               controlId="exampleForm.ControlInput3"
//                             >
//                               <Form.Label className="mb-3">State</Form.Label>
//                               <Form.Control
//                                 type="text"
//                                 placeholder="State"
//                                 value={userOldDetails.state}
//                                 disabled={true}
//                               />
//                             </Form.Group>
//                           </React.Fragment>
//                         ) : (
//                           <Form.Group
//                             className="mt-3"
//                             controlId="exampleForm.ControlInput3"
//                           >
//                             <Form.Label>Licensing Information</Form.Label>
//                             {licenses.map((lic, index) => {
//                               const today = new Date();
//                               today.setHours(0, 0, 0, 0); // remove time part
//                               const expiry = lic.expiry_date
//                                 ? new Date(lic.expiry_date)
//                                 : null;
//                               const isExpired = expiry && expiry < today;
//                               return (
//                                 <div
//                                   key={index}
//                                   className="licenseBox shadow p-3 mt-3 mb-3 bg-body rounded position-relative"
//                                 >
//                                   <div className="d-flex align-items-center  pb-1">
//                                     <p className="mb-0 me-2">
//                                       License #{index + 1}
//                                     </p>
//                                     <div className="ms-auto d-flex align-items-center me-4">
//                                       {lic.verified === "verified" &&
//                                         !isExpired && (
//                                           <span
//                                             className="badge bg-success"
//                                             style={{ fontSize: "12px" }}
//                                           >
//                                             Verified
//                                           </span>
//                                         )}
//                                       {lic.verified === "unverified" &&
//                                         !isExpired && (
//                                           <>
//                                             <span
//                                               className="badge bg-danger"
//                                               style={{ fontSize: "12px" }}
//                                             >
//                                               Unverified
//                                             </span>
//                                             <span
//                                               style={{
//                                                 cursor: "pointer",
//                                                 fontSize: "13px",
//                                                 color: "#1D7E7C",
//                                                 textDecoration: "underline",
//                                                 fontWeight: "bold",
//                                                 marginLeft: "5px",
//                                               }}
//                                               onClick={() => {
//                                                 const map_old_licenses = [
//                                                   ...licenses,
//                                                 ];

//                                                 map_old_licenses[index] = {
//                                                   ...map_old_licenses[index],

//                                                   verified: "not_checked",
//                                                 };
//                                                 map_old_licenses[
//                                                   index
//                                                 ].verified = "not_checked";
//                                                 const removed_old_licenses =
//                                                   old_licenses.filter(
//                                                     (item) =>
//                                                       item.document_unique_id !=
//                                                       lic.document_unique_id
//                                                   );
//                                                 setOldLicenses([
//                                                   ...removed_old_licenses,
//                                                 ]);
//                                                 const extracted_new_licenses = [
//                                                   ...new_licenses,
//                                                 ];
//                                                 const index_of_new_license =
//                                                   extracted_new_licenses.findIndex(
//                                                     (item) =>
//                                                       item.document_unique_id ==
//                                                       lic.document_unique_id
//                                                   );
//                                                 if (
//                                                   index_of_new_license != -1
//                                                 ) {
//                                                   extracted_new_licenses[
//                                                     index_of_new_license
//                                                   ] = map_old_licenses[index];
//                                                   setNewLicenses([
//                                                     ...extracted_new_licenses,
//                                                   ]);
//                                                 } else {
//                                                   setNewLicenses([
//                                                     ...extracted_new_licenses,
//                                                     map_old_licenses[index],
//                                                   ]);
//                                                 }

//                                                 setLicenses([
//                                                   ...map_old_licenses,
//                                                 ]);

//                                                 document.getElementById(
//                                                   `license-file-${index}`
//                                                 ).value = null;
//                                               }}
//                                             >
//                                               Try again
//                                             </span>
//                                           </>
//                                         )}
//                                       {isExpired && (
//                                         <>
//                                           <span
//                                             className="badge bg-warning"
//                                             style={{ fontSize: "12px" }}
//                                           >
//                                             Expired
//                                           </span>
//                                           <span
//                                             style={{
//                                               cursor: "pointer",
//                                               fontSize: "13px",
//                                               color: "#1D7E7C",
//                                               textDecoration: "underline",
//                                               fontWeight: "bold",
//                                               marginLeft: "10px",
//                                             }}
//                                             onClick={() => {
//                                               const map_old_licenses = [
//                                                 ...licenses,
//                                               ];

//                                               map_old_licenses[index] = {
//                                                 ...map_old_licenses[index],

//                                                 verified: "not_checked",
//                                               };
//                                               map_old_licenses[index].verified =
//                                                 "not_checked";
//                                               const removed_old_licenses =
//                                                 old_licenses.filter(
//                                                   (item) =>
//                                                     item.document_unique_id !=
//                                                     lic.document_unique_id
//                                                 );
//                                               setOldLicenses([
//                                                 ...removed_old_licenses,
//                                               ]);
//                                               const extracted_new_licenses = [
//                                                 ...new_licenses,
//                                               ];
//                                               const index_of_new_license =
//                                                 extracted_new_licenses.findIndex(
//                                                   (item) =>
//                                                     item.document_unique_id ==
//                                                     lic.document_unique_id
//                                                 );
//                                               if (index_of_new_license != -1) {
//                                                 extracted_new_licenses[
//                                                   index_of_new_license
//                                                 ] = map_old_licenses[index];
//                                                 setNewLicenses([
//                                                   ...extracted_new_licenses,
//                                                 ]);
//                                               } else {
//                                                 setNewLicenses([
//                                                   ...extracted_new_licenses,
//                                                   map_old_licenses[index],
//                                                 ]);
//                                               }

//                                               setLicenses([
//                                                 ...map_old_licenses,
//                                               ]);

//                                               document.getElementById(
//                                                 `license-file-${index}`
//                                               ).value = null;
//                                             }}
//                                           >
//                                             Upload again
//                                           </span>
//                                         </>
//                                       )}
//                                     </div>
//                                   </div>
//                                   {/* REMOVE BUTTON */}
//                                   {licenses.length > 1 && (
//                                     <FaTimes
//                                       className="position-absolute"
//                                       style={{
//                                         top: 10,
//                                         right: 10,
//                                         cursor: isAnyLicenseVerifying
//                                           ? "not-allowed"
//                                           : "pointer",
//                                         color: "red",
//                                         opacity: isAnyLicenseVerifying
//                                           ? 0.5
//                                           : 1,
//                                       }}
//                                       onClick={() => {
//                                         if (!isAnyLicenseVerifying) {
//                                           const updated = [...licenses];
//                                           const new_licence_updated =
//                                             new_licenses.filter(
//                                               (item) =>
//                                                 item.document_unique_id !=
//                                                 lic.document_unique_id
//                                             );
//                                           const removed_old_licenses =
//                                             old_licenses.filter(
//                                               (item) =>
//                                                 item.document_unique_id !=
//                                                 lic.document_unique_id
//                                             );
//                                           updated.splice(index, 1);
//                                           setOldLicenses([
//                                             ...removed_old_licenses,
//                                           ]);
//                                           setNewLicenses([
//                                             ...new_licence_updated,
//                                           ]);
//                                           setLicenses(updated);
//                                         }
//                                       }}
//                                     />
//                                   )}
//                                   <Form.Control
//                                     type="text"
//                                     placeholder="License Number"
//                                     value={lic.license_number}
//                                     onChange={(e) => {
//                                       if (
//                                         !(lic.verified != "not_checked") &&
//                                         !isAnyLicenseVerifying
//                                       ) {
//                                         const value =
//                                           e.target.value.toUpperCase();
//                                         const updated = [...licenses];
//                                         updated[index].license_number = value;
//                                         const extracted_new_licenses = [
//                                           ...new_licenses,
//                                         ];
//                                         const extracted_old_licenses = [
//                                           ...old_licenses,
//                                         ];
//                                         const index_of_new_license =
//                                           extracted_new_licenses.findIndex(
//                                             (item) =>
//                                               item.document_unique_id ==
//                                               lic.document_unique_id
//                                           );
//                                         if (index_of_new_license != -1) {
//                                           extracted_new_licenses[
//                                             index_of_new_license
//                                           ].license_number = value;
//                                         }
//                                         const index_of_old_license =
//                                           extracted_old_licenses.findIndex(
//                                             (item) =>
//                                               item.document_unique_id ==
//                                               lic.document_unique_id
//                                           );
//                                         if (index_of_old_license != -1) {
//                                           extracted_old_licenses[
//                                             index_of_old_license
//                                           ].license_number = value;
//                                         }
//                                         setLicenses(updated);
//                                         setNewLicenses(extracted_new_licenses);
//                                         setOldLicenses(extracted_old_licenses);
//                                       }
//                                     }}
//                                     disabled={
//                                       lic.verified != "not_checked" ||
//                                       isAnyLicenseVerifying
//                                     }
//                                     style={{
//                                       textTransform: lic.license_number
//                                         ? "uppercase"
//                                         : "none",
//                                     }}
//                                   />

//                                   <Select
//                                     placeholder="Select State"
//                                     className={` ${
//                                       lic.verified !== "not_checked" ||
//                                       isAnyLicenseVerifying
//                                         ? "disabledLicenseSelector"
//                                         : ""
//                                     }`}
//                                     options={statesList}
//                                     values={lic.state}
//                                     onChange={(value) => {
//                                       if (
//                                         !(lic.verified != "not_checked") &&
//                                         !isAnyLicenseVerifying
//                                       ) {
//                                         const updated = [...licenses];
//                                         updated[index].state = value;
//                                         const extracted_new_licenses = [
//                                           ...new_licenses,
//                                         ];
//                                         const extracted_old_licenses = [
//                                           ...old_licenses,
//                                         ];
//                                         const index_of_new_license =
//                                           extracted_new_licenses.findIndex(
//                                             (item) =>
//                                               item.document_unique_id ==
//                                               lic.document_unique_id
//                                           );
//                                         if (index_of_new_license != -1) {
//                                           extracted_new_licenses[
//                                             index_of_new_license
//                                           ].state = value;
//                                         }
//                                         const index_of_old_license =
//                                           extracted_old_licenses.findIndex(
//                                             (item) =>
//                                               item.document_unique_id ==
//                                               lic.document_unique_id
//                                           );
//                                         if (index_of_old_license != -1) {
//                                           extracted_old_licenses[
//                                             index_of_old_license
//                                           ].state = value;
//                                         }
//                                         setLicenses(updated);
//                                         setNewLicenses(extracted_new_licenses);
//                                         setOldLicenses(extracted_old_licenses);
//                                       }
//                                     }}
//                                     multi={false}
//                                     disabled={
//                                       lic.verified != "not_checked" ||
//                                       isAnyLicenseVerifying
//                                     }
//                                     style={{
//                                       color:
//                                         lic.verified != "not_checked"
//                                           ? "#212529"
//                                           : undefined,
//                                       borderColor:
//                                         lic.verified != "not_checked"
//                                           ? "#E9ECEF"
//                                           : undefined,
//                                       opacity:
//                                         lic.verified != "not_checked"
//                                           ? 1
//                                           : undefined,
//                                       backgroundColor:
//                                         lic.verified != "not_checked"
//                                           ? "#E9ECEF"
//                                           : undefined,
//                                     }}
//                                     dropdownHandleRenderer={({ state }) => (
//                                       <span
//                                         style={{
//                                           color:
//                                             lic.verified != "not_checked"
//                                               ? "#212529"
//                                               : undefined,
//                                           opacity:
//                                             lic.verified != "not_checked"
//                                               ? 0
//                                               : undefined,
//                                         }}
//                                       >
//                                         {state.dropdown ? (
//                                           <FaChevronUp />
//                                         ) : (
//                                           <FaChevronDown />
//                                         )}
//                                       </span>
//                                     )}
//                                   />
//                                   {/* UPLOAD BOX */}
//                                   <div className="uploadBox mt-3">
//                                     <p>
//                                       Please upload proof of license
//                                       certification
//                                     </p>
//                                     <div
//                                       className="file"
//                                       style={{
//                                         position: "relative",
//                                         cursor:
//                                           isAnyLicenseVerifying ||
//                                           lic.verified != "not_checked"
//                                             ? "not-allowed"
//                                             : "pointer",
//                                       }}
//                                       onClick={() => {
//                                         if (
//                                           lic.verified == "not_checked" &&
//                                           !isAnyLicenseVerifying
//                                         ) {
//                                           const fileInput =
//                                             document.getElementById(
//                                               `license-file-${index}`
//                                             );
//                                           if (fileInput) fileInput.value = null;
//                                           document
//                                             .getElementById(
//                                               `license-file-${index}`
//                                             )
//                                             .click();
//                                         }
//                                       }}
//                                     >
//                                       {licenses[index].document ? (
//                                         licenses[index].document.isExisting ? (
//                                           // Existing document preview
//                                           licenses[
//                                             index
//                                           ].document.type.includes("image") ? (
//                                             <img
//                                               src={licenses[index].document.url}
//                                               alt="preview"
//                                               style={{
//                                                 width: "100%",
//                                                 height: "150px",
//                                                 objectFit: "contain",
//                                                 border: "1px solid #ccc",
//                                               }}
//                                             />
//                                           ) : (
//                                             <div
//                                               style={{
//                                                 width: "100%",
//                                                 height: "150px",
//                                                 border: "1px solid #ccc",
//                                                 display: "flex",
//                                                 alignItems: "center",
//                                                 justifyContent: "center",
//                                                 flexDirection: "column",
//                                               }}
//                                             >
//                                               <FaFilePdf
//                                                 size={40}
//                                                 color="red"
//                                               />
//                                               <p
//                                                 style={{
//                                                   fontSize: "12px",
//                                                   marginTop: 5,
//                                                 }}
//                                               >
//                                                 {licenses[index].document.name}
//                                               </p>
//                                             </div>
//                                           )
//                                         ) : // New uploaded document preview
//                                         licenses[index].document.type.includes(
//                                             "image"
//                                           ) ? (
//                                           <img
//                                             src={URL.createObjectURL(
//                                               licenses[index].document
//                                             )}
//                                             alt="preview"
//                                             style={{
//                                               width: "100%",
//                                               height: "150px",
//                                               objectFit: "contain",
//                                               border: "1px solid #ccc",
//                                             }}
//                                           />
//                                         ) : (
//                                           <div
//                                             style={{
//                                               width: "100%",
//                                               height: "150px",
//                                               border: "1px solid #ccc",
//                                               display: "flex",
//                                               alignItems: "center",
//                                               justifyContent: "center",
//                                               flexDirection: "column",
//                                             }}
//                                           >
//                                             <FaFilePdf size={40} color="red" />
//                                             <p
//                                               style={{
//                                                 fontSize: "12px",
//                                                 marginTop: 5,
//                                               }}
//                                             >
//                                               {licenses[index].document.name}
//                                             </p>
//                                           </div>
//                                         )
//                                       ) : (
//                                         <span
//                                           className="select_license_document_box"
//                                           htmlFor={`license-file-${index}`}
//                                         >
//                                           <FaCloudUploadAlt /> Upload document
//                                         </span>
//                                       )}
//                                       <input
//                                         id={`license-file-${index}`}
//                                         type="file"
//                                         accept=".pdf,.jpg,.jpeg,.png,.heic"
//                                         style={{ display: "none" }}
//                                         onChange={async (e) => {
//                                           if (
//                                             !(lic.verified != "not_checked") &&
//                                             !isAnyLicenseVerifying
//                                           ) {
//                                             const file = e.target.files[0];
//                                             const updated = [...licenses];
//                                             const extracted_new_licenses = [
//                                               ...new_licenses,
//                                             ];
//                                             const extracted_old_licenses = [
//                                               ...old_licenses,
//                                             ];
//                                             const index_of_new_license =
//                                               extracted_new_licenses.findIndex(
//                                                 (item) =>
//                                                   item.document_unique_id ==
//                                                   lic.document_unique_id
//                                               );
//                                             const index_of_old_license =
//                                               extracted_old_licenses.findIndex(
//                                                 (item) =>
//                                                   item.document_unique_id ==
//                                                   lic.document_unique_id
//                                               );

//                                             if (!file) {
//                                               updated[index].document = null;
//                                               if (index_of_new_license != -1) {
//                                                 extracted_new_licenses[
//                                                   index_of_new_license
//                                                 ].document = null;
//                                               }
//                                               if (index_of_old_license != -1) {
//                                                 extracted_old_licenses[
//                                                   index_of_old_license
//                                                 ].document = null;
//                                               }
//                                               setLicenses(updated);
//                                               setNewLicenses(
//                                                 extracted_new_licenses
//                                               );
//                                               setOldLicenses(
//                                                 extracted_old_licenses
//                                               );
//                                               return;
//                                             }

//                                             const validTypes = [
//                                               "image/jpeg",
//                                               "image/png",
//                                               "image/jpg",
//                                               "application/pdf",
//                                               "image/heic",
//                                             ];
//                                             if (
//                                               !validTypes.includes(file.type)
//                                             ) {
//                                               toast(
//                                                 "Invalid file type. Only JPG, PNG, PDF, HEIC allowed",
//                                                 {
//                                                   position: "top-center",
//                                                   hideProgressBar: true,
//                                                   type: "error",
//                                                 }
//                                               );
//                                               updated[index].document = null;
//                                               if (index_of_new_license != -1) {
//                                                 extracted_new_licenses[
//                                                   index_of_new_license
//                                                 ].document = null;
//                                               }
//                                               if (index_of_old_license != -1) {
//                                                 extracted_old_licenses[
//                                                   index_of_old_license
//                                                 ].document = null;
//                                               }
//                                               setLicenses(updated);
//                                               setNewLicenses(
//                                                 extracted_new_licenses
//                                               );
//                                               setOldLicenses(
//                                                 extracted_old_licenses
//                                               );
//                                               return;
//                                             }

//                                             if (file.size > 10 * 1024 * 1024) {
//                                               toast(
//                                                 "File size exceeds 10MB limit",
//                                                 {
//                                                   position: "top-center",
//                                                   hideProgressBar: true,
//                                                   type: "error",
//                                                 }
//                                               );
//                                               updated[index].document = null;
//                                               if (index_of_new_license != -1) {
//                                                 extracted_new_licenses[
//                                                   index_of_new_license
//                                                 ].document = null;
//                                               }
//                                               if (index_of_old_license != -1) {
//                                                 extracted_old_licenses[
//                                                   index_of_old_license
//                                                 ].document = null;
//                                               }
//                                               setLicenses(updated);
//                                               setNewLicenses(
//                                                 extracted_new_licenses
//                                               );
//                                               setOldLicenses(
//                                                 extracted_old_licenses
//                                               );
//                                               return;
//                                             }

//                                             if (
//                                               file.type === "image/heic" ||
//                                               file.name.endsWith(".heic")
//                                             ) {
//                                               try {
//                                                 const blob = await heic2any({
//                                                   blob: file,
//                                                   toType: "image/jpeg",
//                                                 });
//                                                 const convertedFile = new File(
//                                                   [blob],
//                                                   file.name.replace(
//                                                     ".heic",
//                                                     ".jpg"
//                                                   ),
//                                                   { type: "image/jpeg" }
//                                                 );
//                                                 updated[index].document =
//                                                   convertedFile;
//                                                 if (
//                                                   index_of_new_license != -1
//                                                 ) {
//                                                   extracted_new_licenses[
//                                                     index_of_new_license
//                                                   ].document = convertedFile;
//                                                 }
//                                                 if (
//                                                   index_of_old_license != -1
//                                                 ) {
//                                                   extracted_old_licenses[
//                                                     index_of_old_license
//                                                   ].document = convertedFile;
//                                                 }
//                                                 setLicenses(updated);
//                                                 setNewLicenses(
//                                                   extracted_new_licenses
//                                                 );
//                                                 setOldLicenses(
//                                                   extracted_old_licenses
//                                                 );
//                                               } catch (error) {
//                                                 toast(
//                                                   "Failed to process HEIC image. Please upload a JPG or PNG instead.",
//                                                   {
//                                                     position: "top-center",
//                                                     hideProgressBar: true,
//                                                     type: "error",
//                                                   }
//                                                 );
//                                                 updated[index].document = null;
//                                                 if (
//                                                   index_of_new_license != -1
//                                                 ) {
//                                                   extracted_new_licenses[
//                                                     index_of_new_license
//                                                   ].document = null;
//                                                 }
//                                                 if (
//                                                   index_of_old_license != -1
//                                                 ) {
//                                                   extracted_old_licenses[
//                                                     index_of_old_license
//                                                   ].document = null;
//                                                 }
//                                                 setLicenses(updated);
//                                                 setNewLicenses(
//                                                   extracted_new_licenses
//                                                 );
//                                                 setOldLicenses(
//                                                   extracted_old_licenses
//                                                 );
//                                                 return;
//                                               }
//                                             } else {
//                                               updated[index].document = file;
//                                               if (index_of_new_license != -1) {
//                                                 extracted_new_licenses[
//                                                   index_of_new_license
//                                                 ].document = file;
//                                               }
//                                               if (index_of_old_license != -1) {
//                                                 extracted_old_licenses[
//                                                   index_of_old_license
//                                                 ].document = file;
//                                               }
//                                               setLicenses(updated);
//                                               setNewLicenses(
//                                                 extracted_new_licenses
//                                               );
//                                               setOldLicenses(
//                                                 extracted_old_licenses
//                                               );
//                                             }

//                                             setLicenses(updated);
//                                           }
//                                         }}
//                                       />
//                                     </div>
//                                     <small>
//                                       File size of your documents should not
//                                       exceed 10 MB
//                                     </small>
//                                   </div>

//                                   {/* EXPIRY DATE */}
//                                   {(lic?.verified !== "not_checked" ||
//                                     (submit &&
//                                       (!lic?.expiry_date ||
//                                         lic?.verified == "not_checked")) ||
//                                     (lic?.verified == "not_checked" &&
//                                       lic.expiry_date)) && (
//                                     <div className="mt-3">
//                                       <Form.Label>
//                                         License Expiry Date
//                                       </Form.Label>
//                                       <Form.Control
//                                         type="text"
//                                         value={
//                                           lic?.expiry_date
//                                             ? lic?.expiry_date
//                                             : ""
//                                         }
//                                         placeholder="Expiry Date"
//                                         min={
//                                           new Date().toISOString().split("T")[0]
//                                         }
//                                         onClick={(e) => {
//                                           setSelectedLicense({
//                                             ...lic,
//                                             index,
//                                           });
//                                           setShowExpiryDateModel(true);
//                                         }}
//                                         disabled={
//                                           (lic.verifying ||
//                                             isAnyLicenseVerifying ||
//                                             lic.verified !== "not_checked") &&
//                                           lic?.expiry_date
//                                         }
//                                       />
//                                       {submit && !lic?.expiry_date && (
//                                         <span
//                                           className="validations_err"
//                                           style={errorStyle}
//                                         >
//                                           This field is required
//                                         </span>
//                                       )}
//                                     </div>
//                                   )}
//                                   {/* VERIFY BUTTON */}

//                                   {![
//                                     "verified",
//                                     "verifying",
//                                     "unverified",
//                                   ].includes(lic.verified) &&
//                                     validateLicensesForExpiryDate() == null && (
//                                       <>
//                                         <Button
//                                           className="mt-2"
//                                           onClick={() => verifyLicense(index)}
//                                           disabled={isAnyLicenseVerifying}
//                                         >
//                                           {lic.verifying
//                                             ? "Verifying..."
//                                             : "Verify"}
//                                         </Button>
//                                         {lic.verifying && (
//                                           <div
//                                             className="mt-2 p-2"
//                                             style={{
//                                               backgroundColor: "#e3f2fd",
//                                               border: "1px solid #1D7E7C",
//                                               borderRadius: "5px",
//                                               fontSize: "14px",
//                                               color: "#1A3D3C",
//                                             }}
//                                           >
//                                             <div className="d-flex align-items-center">
//                                               <div
//                                                 className="spinner-border spinner-border-sm me-2"
//                                                 role="status"
//                                               >
//                                                 <span className="visually-hidden">
//                                                   Loading...
//                                                 </span>
//                                               </div>
//                                               <span>
//                                                 <strong>
//                                                   Verifying your license...
//                                                 </strong>
//                                                 <br />
//                                                 Processing your request, this
//                                                 may take a moment.
//                                               </span>
//                                             </div>
//                                           </div>
//                                         )}
//                                       </>
//                                     )}
//                                 </div>
//                               );
//                             })}

//                             {licenses.every(
//                               (lic) => lic.verified != "not_checked"
//                             ) &&
//                               validateLicenses() == null &&
//                               !isAnyLicenseVerifying && (
//                                 <Button
//                                   className="mb-3"
//                                   onClick={() => {
//                                     const unique_id = get_unique_id();
//                                     setLicenses([
//                                       ...licenses,
//                                       {
//                                         document_unique_id: unique_id,
//                                         license_number: "",
//                                         state: [],
//                                         document: null,
//                                         expiry_date: "",
//                                         verified: "not_checked",
//                                         verifying: false,
//                                         file_path: "",
//                                       },
//                                     ]);
//                                     setNewLicenses([
//                                       ...new_licenses,
//                                       {
//                                         document_unique_id: unique_id,
//                                         license_number: "",
//                                         state: [],
//                                         document: null,
//                                         expiry_date: "",
//                                         verified: "not_checked",
//                                         verifying: false,
//                                         file_path: "",
//                                       },
//                                     ]);
//                                   }}
//                                   disabled={isAnyLicenseVerifying}
//                                   style={{
//                                     whiteSpace: "nowrap",
//                                     textAlign: "center",
//                                     minWidth: "200px",
//                                     width: "auto",
//                                   }}
//                                 >
//                                   Add More License
//                                 </Button>
//                               )}
//                             {submit && validationsRes.licensesErr && (
//                               <span
//                                 className="validations_err"
//                                 style={errorStyle}
//                               >
//                                 {validationsRes.licensesErr}
//                               </span>
//                             )}
//                           </Form.Group>
//                         )}

//                         <Form.Group
//                           className="mt-3"
//                           controlId="exampleForm.ControlInput3"
//                         >
//                           <Form.Label className="mb-3">
//                             Supervisor's Name (if applicable)
//                           </Form.Label>
//                           <Form.Control
//                             type="text"
//                             placeholder="Supervisor's Name (if applicable)"
//                             value={supervisor_name}
//                             onChange={(e) => {
//                               setSupervisorName(e.target.value);
//                             }}
//                           />
//                         </Form.Group>

//                         <Form.Group
//                           className="mb-3"
//                           controlId="exampleForm.ControlInput3"
//                           style={{ position: "relative", zIndex: 5 }}
//                         >
//                           <Form.Label className="mb-3">
//                             Select Specialty
//                           </Form.Label>
//                           <MultiSelect
//                             options={specialityList}
//                             value={speciality}
//                             className="checkBoxNew"
//                             onChange={setSpeciality}
//                             labelledBy="Select Specialty"
//                           />
//                         </Form.Group>
//                         {submit && validationsRes.specialityErr && (
//                           <span className="validations_err" style={errorStyle}>
//                             {validationsRes.specialityErr}
//                           </span>
//                         )}

//                         <Form.Group
//                           className="mb-3"
//                           controlId="exampleForm.ControlInput3"
//                           style={{ position: "relative", zIndex: 3 }}
//                         >
//                           <Form.Label className="mb-3">
//                             Select Language
//                           </Form.Label>
//                           <MultiSelect
//                             options={languageLIst}
//                             value={language}
//                             className="checkBoxNew"
//                             onChange={setLanguage}
//                             labelledBy="Select Language"
//                           />
//                         </Form.Group>
//                         {submit && validationsRes.languageErr && (
//                           <span className="validations_err" style={errorStyle}>
//                             {validationsRes.languageErr}
//                           </span>
//                         )}
//                         <Form.Group
//                           className="mb-3"
//                           controlId="exampleForm.ControlInput3"
//                           style={{ position: "relative", zIndex: 2 }}
//                         >
//                           <Form.Label className="flable">
//                             Qualification
//                           </Form.Label>
//                           <MultiSelect
//                             options={certificateList}
//                             value={licence}
//                             className="checkBoxNew"
//                             onChange={setLicence}
//                             labelledBy="Select License Types"
//                           />
//                         </Form.Group>
//                         {submit && validationsRes.licenceErr && (
//                           <span className="validations_err" style={errorStyle}>
//                             {validationsRes.licenceErr}
//                           </span>
//                         )}

//                         <div className="availableBox">
//                           <Form.Group
//                             className="mb-4"
//                             controlId="exampleForm.ControlInput3"
//                           >
//                             <Form.Label className="mb-3">
//                               Set Your Availability
//                             </Form.Label>
//                             {daysArray.map((item, index) => {
//                               return (
//                                 <div key={index} className="listItem">
//                                   <Form.Check
//                                     aria-label="option 1"
//                                     checked={item.checked}
//                                     onChange={() => {
//                                       check_uncheck_fun(item.id);
//                                     }}
//                                   />
//                                   <span
//                                     className="days"
//                                     style={{
//                                       backgroundColor: item.checked
//                                         ? ""
//                                         : "gray",
//                                     }}
//                                   >
//                                     {item.day}
//                                   </span>
//                                   <span className="from">From</span>
//                                   <LocalizationProvider
//                                     dateAdapter={AdapterDayjs}
//                                   >
//                                     <TimePicker
//                                       label={!item.start_time && "Start Time"}
//                                       value={
//                                         item.start_time
//                                           ? dayjs(item.start_time)
//                                           : null
//                                       }
//                                       onChange={(newValue) =>
//                                         setStartTimeFun(item.id, newValue.$d)
//                                       }
//                                     />
//                                   </LocalizationProvider>

//                                   <span className="from">To</span>
//                                   <LocalizationProvider
//                                     dateAdapter={AdapterDayjs}
//                                   >
//                                     <TimePicker
//                                       label={!item.end_time && "End Time"}
//                                       value={
//                                         item.end_time
//                                           ? dayjs(item.end_time)
//                                           : null
//                                       }
//                                       onChange={(newValue) =>
//                                         setEndTimeFun(item.id, newValue.$d)
//                                       }
//                                     />
//                                   </LocalizationProvider>
//                                 </div>
//                               );
//                             })}
//                           </Form.Group>
//                           {submit && validationsRes.availabilityErr && (
//                             <span
//                               className="validations_err"
//                               style={errorStyle}
//                             >
//                               {validationsRes.availabilityErr}
//                             </span>
//                           )}
//                         </div>

//                         <div className="availableBox">
//                           <Form.Group
//                             className="mb-4"
//                             controlId="exampleForm.ControlInput3"
//                           >
//                             <Form.Label className="mb-3">
//                               Set Pricing
//                             </Form.Label>
//                             {pricingArr.map((item, index) => {
//                               return (
//                                 <div
//                                   key={index}
//                                   className="listItem listItem_price"
//                                 >
//                                   <Form.Check
//                                     aria-label="option 1"
//                                     checked={item.checked}
//                                     onChange={() => {
//                                       check_uncheck_pricing_fun(item.id, index);
//                                     }}
//                                   />
//                                   <Form.Control
//                                     type="text"
//                                     placeholder={`${item.time_in_min} mins`}
//                                     disabled
//                                   />
//                                   <span className="from">Price</span>
//                                   <div className="price">
//                                     <span>$</span>
//                                     <Form.Control
//                                       ref={(ele) => {
//                                         priceInputRefs.current[index] = ele;
//                                       }}
//                                       type="text"
//                                       placeholder="0"
//                                       value={item.price}
//                                       onChange={(e) => {
//                                         const numericValue =
//                                           e.target.value.replace(/[^0-9]/g, "");
//                                         setTimeValueFun(item.id, numericValue);
//                                       }}
//                                       // onBlur={() => {
//                                       //   handleBlurOfPriceInput(item, index);
//                                       // }}
//                                     />
//                                   </div>
//                                 </div>
//                               );
//                             })}
//                           </Form.Group>
//                           {submit && validationsRes.pricingErr && (
//                             <span
//                               className="validations_err"
//                               style={errorStyle}
//                             >
//                               {validationsRes.pricingErr}
//                             </span>
//                           )}
//                           <div
//                             className="d-flex justify-contetent between align-items-center"
//                             style={{ columnGap: 20, marginBottom: "1em" }}
//                           >
//                             <Button
//                               className="btn btn-primary w-50"
//                               onClick={() => {
//                                 handle_submit();
//                               }}
//                             >
//                               Submit
//                             </Button>
//                             <Button
//                               onClick={() => setShowDelConfirmationModal(true)}
//                               className="btn btn-primary w-50"
//                             >
//                               Delete Account
//                             </Button>
//                           </div>
//                         </div>
//                       </div>
//                     </Form>
//                   </div>
//                 </div>

//                 <MyVerticallyCenteredModal
//                   show={modalShow}
//                   onHide={() => setModalShow(false)}
//                 />
//                 <Date_model show={showDateModel} />
//                 <Expiry_Date_model show={showExpiryDateModel} />
//                 <DeleteAccountConfirmationModal
//                   show={showDelConfirmationModal}
//                 />
//                 {show_otp_modal && (
//                   <Otp_model
//                     show={true}
//                     onHide={() => {
//                       setShowOtpModal(false);
//                     }}
//                     verify_type="update_profile"
//                     handle_profile_update={submitFun}
//                   />
//                 )}
//               </div>
//             </div>
//           )}
//         </div>
//       </section>
//     </>
//   );
// };

// export default TherapistEditProfile;
